<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="7"
        xl="8"
        :style="$vuetify.breakpoint.xlOnly ? 'margin-left: -40px' : ''"
      >
        <div class="d-flex">
          <div class="pt-1 pr-2">
            <v-btn icon @click="backToPreviousScreen">
              <v-icon size="34" color="accent"
                >icon-alertadis-angle-left-b</v-icon
              >
            </v-btn>
          </div>
          <div>
            <div class="historical-data-title">
              <span>Dados históricos</span>
            </div>
            <div>
              <span class="historical-data-sub-title"
                >Consulte os dados de eventos passados.</span
              >
            </div>
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="12" md="12" lg="5" xl="4" style="height: 40px">
        <div
          class="py-2 pr-2 pl-1 graph-table-chip d-flex"
          style="max-width: 775px"
        >
          <v-btn
            height="24"
            class="daily-btn daily-btn-active"
            @click="toggleNavigation"
            elevation="0"
          >
            <span class="historical-btn-text" v-if="typeLocation == 'regional'">
              REGIONAL
              {{ filterSelected.location.fullname.toUpperCase() }}</span
            >

            <span class="historical-btn-text" v-if="typeLocation == 'agency'">
              Base de Serviço de Campo
              {{ filterSelected.location.name.toUpperCase() }}</span
            >
            <span class="historical-btn-text" v-if="typeLocation == 'countie'">
              MUNICÍPIO
              {{ filterSelected.location.name.toUpperCase() }}</span
            >
          </v-btn>

          <v-btn
            height="24"
            class="daily-btn daily-btn-active"
            @click="toggleNavigation"
          >
            <span class="daily-btn-text" v-if="daily == true"
              >{{ moment(dailyDataFilter[0]).format("ddd. DD/MM/YYYY") }} a
              {{
                dailyPeriodsTable.dates[dailyPeriodsTable.dates.length - 1].name
              }}</span
            >

            <span class="daily-btn-text" v-if="daily == false"
              >{{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
              {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
              às
              {{
                moment(hourlyDataFilter[hourlyDataFilter.length - 1])
                  .utc()
                  .format("HH:mm")
              }}</span
            >
          </v-btn>

          <v-btn
            height="24"
            @click="toggleNavigation"
            dense
            elevation="0"
            color="#151723"
          >
            <v-icon> icon-alertadis-tune </v-icon>
            <span class="daily-btn-text btn-filter">Filtrar</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row class="pt-2">
      <v-col cols="12" sm="12" md="12" lg="5">
        <div class="ci-forecast-title">Previsão de Consumidor Interrompido</div>
        <div class="ci-forecast-sub-title">
          Verifique o que foi previsto para o dia ou a hora selecionada.
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="7">
        <div class="py-2 forecast-time-text">
          {{ daily ? forecastDate : forecastTime }}
        </div>
        <div v-if="daily" class="d-flex flex-wrap graph-table-chip">
          <v-slide-group
            multiple
            mandatory
         
          >
            <v-slide-item
              v-for="(daily, i) in dailyPeriodsTable.dates"
              :key="i"
            >
              <v-btn
                height="24"
                :disabled="loading && loadingForecast"
                :class="
                  isSelectedDaily(daily)
                    ? 'daily-btn daily-btn-active'
                    : 'daily-btn'
                "
                @click="toggleItemDaily(daily)"
              >
                <span class="daily-btn-text">{{ daily.name }}</span>
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </div>
        <div v-else>
          <div class="d-flex flex-wrap justify-end graph-table-chip">
            <v-slide-group multiple :show-arrows="false">
              <v-slide-item v-for="(hour, i) in hourlyPeriodsTable" :key="i">
                <v-btn
                  height="24"
                  :disabled="loading && loadingForecast"
                  :class="
                    isSelectedHour(hour)
                      ? 'daily-btn daily-btn-active'
                      : 'daily-btn'
                  "
                  @click="toggleItemHour(hour)"
                >
                  <span class="daily-btn-text">{{ hour.name }}</span>
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row v-show="typeLocation == 'regional'" id="regional">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-lightbulb-off-outline </v-icon>
          Previsão de Consumidor Interrompido nas Base de Serviço de Campo (unidade
          consumidoras)
          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('regional')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('regional')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle class="card-subtitle" v-if="daily == true">
          Previsão de interrupções nas Base de Serviço de Campo da regional
          {{ filterSelected.location.fullname }} -
          {{
            daily
              ? moment(dailyDataFilter[0]).format("DD/MM/YYYY")
              : hourlyPeriodsTable[0].name
          }}
          a
          {{
            daily
              ? moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
                  "DD/MM/YYYY"
                )
              : hourlyPeriodsTable[hourlyPeriodsTable.length - 1].name
          }}
        </v-card-subtitle>

        <v-card-subtitle class="card-subtitle" v-if="daily == false">
          Previsão de interrupções nas Base de Serviço de Campo da regional
          {{ filterSelected.location.fullname }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            class="table-style"
            :headers="headers"
            hide-default-footer
            disable-pagination
            :items="predictedDataItemsRegional"
            group-by="agency"
            height="600px"
            id="predictionDataTable"
            fixed-header
            :loading="loading"
          >
            <template v-slot:[`group.header`]="{ group }">
              <td :colspan="headers.length">
                <div class="group-agency">{{ group }}</div>
              </td>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                style="
                  color: #b4dbff;
                  background: rgba(75, 166, 251, 0.1);
                  height: 78px;
                  width: 180px;
                "
              >
                {{
                  daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.column0`]="{ item }">
              <span class="item-style">{{
                typeof item.column0 != "undefined" ? item.column0 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column1`]="{ item }">
              <span class="item-style">{{
                typeof item.column1 != "undefined" ? item.column1 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column2`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column2 != "undefined" ? item.column2 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column3`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column3 != "undefined" ? item.column3 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column4`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column4 != "undefined" ? item.column4 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column5`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column5 != "undefined" ? item.column5 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column6`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column6 != "undefined" ? item.column6 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column7`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column7 != "undefined" ? item.column7 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column8`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column8 != "undefined" ? item.column8 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column9`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column9 != "undefined" ? item.column9 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column10`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column10 != "undefined" ? item.column10 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column11`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column11 != "undefined" ? item.column11 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column12`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column12 != "undefined" ? item.column12 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column13`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column13 != "undefined" ? item.column13 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column14`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column14 != "undefined" ? item.column14 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column15`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column15 != "undefined" ? item.column15 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column16`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column16 != "undefined" ? item.column16 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column17`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column17 != "undefined" ? item.column17 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column18`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column18 != "undefined" ? item.column18 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column19`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column19 != "undefined" ? item.column19 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column20`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column20 != "undefined" ? item.column20 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column21`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column21 != "undefined" ? item.column21 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column22`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column22 != "undefined" ? item.column22 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column23`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column23 != "undefined" ? item.column23 : "-"
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row v-show="typeLocation == 'regional'" id="oneRegional" class="pt-5">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-lightbulb-off-outline </v-icon>
          Previsão de Consumidor Interrompido na regional

          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('oneRegional')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable
            @exportXLS="exportXLS('oneRegional')"
          ></MenuExportTable>
        </v-card-title>

        <v-card-subtitle class="card-subtitle" v-if="daily == true">
          Previsão de interrupções na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle class="card-subtitle" v-if="daily == false">
          Previsão de interrupções na regional
          {{ filterSelected.location.fullname }}
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            hide-default-footer
            disable-pagination
            :items="forecastDataItemsRegional"
            height="600px"
            id="predictionDataTable"
            fixed-header
            :loading="loadingRegional"
            :headers="headers"
          >
            <template v-slot:[`item.runtime`]="{ item }">
              <td
                style="
                  color: #b4dbff;
                  background: rgba(75, 166, 251, 0.1);
                  height: 78px;
                "
              >
                {{
                  daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.column0`]="{ item }">
              <span class="item-style">{{
                typeof item.column0 != "undefined" ? item.column0 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column1`]="{ item }">
              <span class="item-style">{{
                typeof item.column1 != "undefined" ? item.column1 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column2`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column2 != "undefined" ? item.column2 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column3`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column3 != "undefined" ? item.column3 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column4`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column4 != "undefined" ? item.column4 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column5`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column5 != "undefined" ? item.column5 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column6`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column6 != "undefined" ? item.column6 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column7`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column7 != "undefined" ? item.column7 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column8`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column8 != "undefined" ? item.column8 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column9`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column9 != "undefined" ? item.column9 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column10`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column10 != "undefined" ? item.column10 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column11`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column11 != "undefined" ? item.column11 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column12`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column12 != "undefined" ? item.column12 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column13`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column13 != "undefined" ? item.column13 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column14`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column14 != "undefined" ? item.column14 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column15`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column15 != "undefined" ? item.column15 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column16`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column16 != "undefined" ? item.column16 : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column17`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column17 != "undefined" ? item.column17 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column18`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column18 != "undefined" ? item.column18 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column19`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column19 != "undefined" ? item.column19 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column20`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column20 != "undefined" ? item.column20 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column21`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column21 != "undefined" ? item.column21 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column22`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column22 != "undefined" ? item.column22 : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column23`]="{ item }">
              <span class="pr-15 item-style">{{
                typeof item.column23 != "undefined" ? item.column23 : "-"
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row v-show="typeLocation == 'agency'" id="agency">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-lightbulb-off-outline </v-icon>
          Previsão de Consumidor Interrompido nos municípios (unidade
          consumidoras)

          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('agency')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('agency')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle class="card-subtitle" v-if="daily == true">
          Previsão de interrupções nos municípios da agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle class="card-subtitle" v-if="daily == false">
          Previsão de interrupções nos municípios da agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            hide-default-footer
            disable-pagination
            :items="predictedDataItemsAgency"
            group-by="locationName"
            height="600px"
            id="predictionDataTable"
            fixed-header
            :loading="loading"
            :headers="headers"
          >
            <template #header>
              <tr>
                <th
                  v-for="(h, i) in headers"
                  :key="i"
                  :class="createStyleHeader(i)"
                >
                  <div v-if="i != 0">
                    <span class="pr-15 header-sub-style">MIN</span>
                    <span class="header-sub-style pr-4">MAX</span>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:[`group.header`]="{ group }">
              <td :colspan="headers.length">
                <div class="group-agency">{{ group }}</div>
              </td>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                style="
                  color: #b4dbff;
                  background: rgba(75, 166, 251, 0.1);
                  height: 78px;
                  width: 180px;
                "
              >
                {{
                  daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.column0`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column0 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column0 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column1`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column1 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column1 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column2`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column2 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column2 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column3`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column3 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column3 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column4`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column4 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column4 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column5`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column5 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column5 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column6`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column6 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column6 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column7`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column7 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column7 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column8`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column8 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column8 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column9`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column9 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column9 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column10`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column10 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column10 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column11`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column11 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column11 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column12`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column12 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column12 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column13`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column13 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column13 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column14`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column14 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column14 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column15`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column15 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column15 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column16`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column16 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column16 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column17`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column17 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column17 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column18`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column18 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column18 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column19`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column19 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column19 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column20`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column20 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column20 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column21`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column21 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column21 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column22`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column22 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column22 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column23`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column23 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column23 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row v-show="typeLocation == 'countie'" id="countie">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-lightbulb-off-outline </v-icon>
          Previsão de Consumidor Interrompido no município

          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('countie')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('countie')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle class="card-subtitle" v-if="daily == true">
          Previsão de interrupções em
          {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle class="card-subtitle" v-if="daily == false">
          Previsão de interrupções em
          {{ filterSelected.location.name }}
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            hide-default-footer
            disable-pagination
            :items="predictedDataItemsCountie"
            height="600px"
            id="predictionDataTable"
            fixed-header
            :loading="loading"
            :headers="headers"
          >
            <template #header>
              <tr>
                <th
                  v-for="(h, i) in headers"
                  :key="i"
                  :class="createStyleHeader(i)"
                >
                  <div v-if="i != 0">
                    <span class="pr-15 header-sub-style">MIN</span>
                    <span class="header-sub-style pr-4">MAX</span>
                  </div>
                </th>
              </tr>
            </template>
            <template v-slot:[`group.header`]="{ group }">
              <td :colspan="headers.length">
                <div class="group-agency">{{ group }}</div>
              </td>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                style="
                  color: #b4dbff;
                  background: rgba(75, 166, 251, 0.1);
                  height: 78px;
                "
              >
                {{
                  daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.column0`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column0 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column0 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column1`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column1 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column1 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column2`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column2 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column2 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column3`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column3 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column3 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column4`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column4 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column4 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column5`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column5 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column5 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column6`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column6 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column6 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column7`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column7 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column7 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column8`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column8 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column8 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column9`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column9 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column9 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column10`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column10 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column10 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column11`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column11 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column11 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column12`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column12 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column12 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column13`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column13 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column13 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column14`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column14 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column14 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column15`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column15 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column15 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column16`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column16 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column16 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>

            <template v-slot:[`item.column17`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column17 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column17 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column18`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column18 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column18 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column19`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column19 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column19 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column20`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column20 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column20 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column21`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column21 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column21 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column22`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column22 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column22 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
            <template v-slot:[`item.column23`]="{ item }">
              <span class="pr-15 item-style" :style="{ color: item.color }">{{
                typeof item.column23 != "undefined" ? item.cistart : "-"
              }}</span>
              <span class="item-style pr-4" :style="{ color: item.color }">{{
                typeof item.column23 != "undefined" ? item.cistop : "-"
              }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="pt-5" id="wind">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-wind </v-icon>
          Rajada máxima de vento (km/h)

          <v-spacer> </v-spacer>
          <div class="legend-style">
            <span
              style="background: #828d9e; color: #828d9e"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="#828d9e">Fraco</span>
          </div>

          <div class="legend-style">
            <span
              style="background: #e5c000; color: #e5c000"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #e5c000"
              >Moderado</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #df9f3e; color: #df9f3e"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #df9f3e"
              >Forte</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #b4374b; color: #b4374b"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #b4374b"
              >Intenso</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #b94d8a; color: #b94d8a"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #b94d8a"
              >Extremo</span
            >
          </div>

          <v-btn icon small @click="changeToFullSreen('wind')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('wind')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == true"
        >
          Dados previstos e registrados da rajada máxima de vento na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == false"
        >
          Dados previstos e registrados da rajada máxima de vento na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == true"
        >
          Dados previstos e registrados da rajada máxima de vento na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == false"
        >
          Dados previstos e registrados da rajada máxima de vento na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == true"
        >
          Dados previstos e registrados da rajada máxima de vento em
          {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == false"
        >
          Dados previstos e registrados da rajada máxima de vento em
          {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            class="table-style"
            :headers="headersWindGust"
            hide-default-footer
            disable-pagination
            :items="forecastsDataItemsWind"
            id="predictionDataTable"
            :loading="loadingForecast"
            :group-by="typeLocation != 'countie' ? 'agroup' : []"
            fixed-header
            ref="wind"
            height="65vh"
          >
            <template
              v-slot:[`group.header`]="{ isOpen, toggle, group }"
              v-if="typeLocation != 'countie'"
            >
              <td
                style="color: #558a80; background: #e7fdf5; height: 78px"
                v-if="group"
              >
                <div class="d-flex">
                  <div class="pr-3">
                    <v-btn icon @click="toggle(!isOpen)">
                      <v-icon v-show="!isOpen" color="#558A80">
                        mdi-plus-circle-outline</v-icon
                      >
                      <v-icon v-show="isOpen" color="#558A80">
                        mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                  </div>

                  <v-divider vertical></v-divider>
                  <span> Dados Reegistrados nas estações</span>
                </div>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[0]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[0].windGust
                        ),
                      }"
                      >{{ higherStationData[0].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[1]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[1].windGust
                        ),
                      }"
                      >{{ higherStationData[1].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[2]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[2].windGust
                        ),
                      }"
                      >{{ higherStationData[2].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[3]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[3].windGust
                        ),
                      }"
                      >{{ higherStationData[3].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[4]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[4].windGust
                        ),
                      }"
                      >{{ higherStationData[4].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[5]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[5].windGust
                        ),
                      }"
                      >{{ higherStationData[5].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[6]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[6].windGust
                        ),
                      }"
                      >{{ higherStationData[6].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[7]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[7].windGust
                        ),
                      }"
                      >{{ higherStationData[7].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[8]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[8].windGust
                        ),
                      }"
                      >{{ higherStationData[8].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[9]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[9].windGust
                        ),
                      }"
                      >{{ higherStationData[9].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[10]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[10].windGust
                        ),
                      }"
                      >{{ higherStationData[10].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[11]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[11].windGust
                        ),
                      }"
                      >{{ higherStationData[11].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[12]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[12].windGust
                        ),
                      }"
                      >{{ higherStationData[12].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[13]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[13].windGust
                        ),
                      }"
                      >{{ higherStationData[13].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[14]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[14].windGust
                        ),
                      }"
                      >{{ higherStationData[14].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[15]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[15].windGust
                        ),
                      }"
                      >{{ higherStationData[15].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[16]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[16].windGust
                        ),
                      }"
                      >{{ higherStationData[16].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[17]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[17].windGust
                        ),
                      }"
                      >{{ higherStationData[17].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[18]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[18].windGust
                        ),
                      }"
                      >{{ higherStationData[18].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[19]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[19].windGust
                        ),
                      }"
                      >{{ higherStationData[19].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[20]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[20].windGust
                        ),
                      }"
                      >{{ higherStationData[20].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[21]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[21].windGust
                        ),
                      }"
                      >{{ higherStationData[21].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[22]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[22].windGust
                        ),
                      }"
                      >{{ higherStationData[22].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[23]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getWindGustTypeColor(
                          higherStationData[23].windGust
                        ),
                      }"
                      >{{ higherStationData[23].windGust }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior rajada no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template
              v-slot:[`body.append`]
              v-if="typeLocation == 'countie' && loadingForecast == false"
            >
              <tr>
                <td style="color: #558a80; background: #e7fdf5; height: 78px">
                  <span>Estação {{ filterSelected.location.name }} </span>
                </td>

                <td
                  class="text-end v-data-table__divider"
                  v-for="(data, i) in registeredDataItems"
                  :key="i"
                >
                  <span :style="{ color: getWindGustTypeColor(data.windGust) }">
                    {{ data.windGust }}</span
                  >
                </td>
              </tr>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                :style="{
                  color: item.color,
                  background: item.background,
                  height: item.height,
                }"
              >
                {{
                  item.cityName
                    ? item.cityName
                    : daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.windGust0`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust0) }"
                    >{{
                      typeof item.windGust0 != "undefined" || item.windGust0
                        ? item.windGust0
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust0, 0, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust1`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust1) }"
                    >{{
                      typeof item.windGust1 != "undefined"
                        ? item.windGust1
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust1, 1, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.windGust2`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust2) }"
                    >{{
                      typeof item.windGust2 != "undefined"
                        ? item.windGust2
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust2, 2, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust3`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust3) }"
                    >{{
                      typeof item.windGust3 != "undefined"
                        ? item.windGust3
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust3, 3, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust4`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust4) }"
                    >{{
                      typeof item.windGust4 != "undefined"
                        ? item.windGust4
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust4, 4, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust5`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust5) }"
                    >{{
                      typeof item.windGust5 != "undefined"
                        ? item.windGust5
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust5, 5, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust6`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust6) }"
                    >{{
                      typeof item.windGust6 != "undefined"
                        ? item.windGust6
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust6, 6, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust7`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust7) }"
                    >{{
                      typeof item.windGust7 != "undefined"
                        ? item.windGust7
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust7, 7, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust8`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust8) }"
                    >{{
                      typeof item.windGust8 != "undefined"
                        ? item.windGust8
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust8, 8, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust9`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust9) }"
                    >{{
                      typeof item.windGust9 != "undefined"
                        ? item.windGust9
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust9, 9, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust10`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust10) }"
                    >{{
                      typeof item.windGust10 != "undefined"
                        ? item.windGust10
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust10, 10, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust11`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust11) }"
                    >{{
                      typeof item.windGust11 != "undefined"
                        ? item.windGust11
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust11, 11, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust12`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust12) }"
                    >{{
                      typeof item.windGust12 != "undefined"
                        ? item.windGust12
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust12, 12, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust13`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust13) }"
                    >{{
                      typeof item.windGust13 != "undefined"
                        ? item.windGust13
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust13, 13, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust14`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust14) }"
                    >{{
                      typeof item.windGust14 != "undefined"
                        ? item.windGust14
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust14, 14, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust15`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust15) }"
                    >{{
                      typeof item.windGust15 != "undefined"
                        ? item.windGust15
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust15, 15, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust16`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust16) }"
                    >{{
                      typeof item.windGust16 != "undefined"
                        ? item.windGust16
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust16, 15, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust17`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust17) }"
                    >{{
                      typeof item.windGust17 != "undefined"
                        ? item.windGust17
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust17, 17, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust18`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust18) }"
                    >{{
                      typeof item.windGust18 != "undefined"
                        ? item.windGust18
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust18, 18, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust19`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust19) }"
                    >{{
                      typeof item.windGust19 != "undefined"
                        ? item.windGust19
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust19, 19, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust20`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust20) }"
                    >{{
                      typeof item.windGust20 != "undefined"
                        ? item.windGust20
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust20, 19, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust21`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust21) }"
                    >{{
                      typeof item.windGust21 != "undefined"
                        ? item.windGust21
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust21, 21, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.windGust22`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust22) }"
                    >{{
                      typeof item.windGust22 != "undefined"
                        ? item.windGust22
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust22, 22, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.windGust23`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getWindGustTypeColor(item.windGust23) }"
                    >{{
                      typeof item.windGust23 != "undefined"
                        ? item.windGust23
                        : "-"
                    }}</span
                  >
                </v-col>

                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.windGust23, 23, 'windGust') &&
                      typeLocation != 'countie' &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior rajada no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="pt-5" id="preci">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon class="pr-1" x-small>
            icon-alertadis-cloud-showers-alt
          </v-icon>
          Precipitação (mm)

          <v-spacer> </v-spacer>
          <div class="legend-style">
            <span
              style="background: #9e9e9e; color: #9e9e9e"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #9e9e9e"
              >Sem alerta</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #bed7dc; color: #bed7dc"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #bed7dc"
              >Elevada</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #9bc3cd; color: #9bc3cd"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #9bc3cd"
              >Moderada
            </span>
          </div>

          <div class="legend-style">
            <span
              style="background: #73a5b4; color: #73a5b4"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #73a5b4"
              >Forte</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #4b879b; color: #4b879b"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #4b879b"
              >Intensa</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #286e82; color: #286e82"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #286e82"
              >Extrema</span
            >
          </div>

          <v-btn icon small @click="changeToFullSreen('preci')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('preci')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == true"
        >
          Dados previstos e registrados de precipitação na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == false"
        >
          Dados previstos e registrados de precipitação na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == true"
        >
          Dados previstos e registrados de precipitação na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>
        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == false"
        >
          Dados previstos e registrados de precipitação na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == true"
        >
          Dados previstos e registrados de precipitação em
          {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == false"
        >
          Dados previstos e registrados de precipitação em
          {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            class="table-style"
            :headers="headersPreci"
            hide-default-footer
            disable-pagination
            :items="forecastsDataItemsPrecip"
            height="600px"
            id="predictionDataTable"
            :loading="loadingForecast"
            :group-by="typeLocation != 'countie' ? 'agroup' : []"
            fixed-header
          >
            <template
              v-slot:[`group.header`]="{ isOpen, toggle, group }"
              v-if="typeLocation != 'countie'"
            >
              <td
                style="color: #558a80; background: #e7fdf5; height: 78px"
                v-if="group"
              >
                <div class="d-flex">
                  <div class="pr-3">
                    <v-btn icon @click="toggle(!isOpen)">
                      <v-icon v-show="!isOpen" color="#558A80">
                        mdi-plus-circle-outline</v-icon
                      >
                      <v-icon v-show="isOpen" color="#558A80">
                        mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                  </div>

                  <v-divider vertical></v-divider>
                  <span> Dados Reegistrados nas estações</span>
                </div>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[0]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[0].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[0].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[1]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[1].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[1].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[2]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[2].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[2].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[3]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[3].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[3].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[4]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[4].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[4].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[5]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[5].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[5].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[6]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[6].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[6].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[7]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[7].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[7].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[8]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[8].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[8].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[9]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[9].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[9].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[10]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[10].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[10].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[11]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[11].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[11].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[12]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[12].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[12].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[13]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[13].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[13].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[14]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[14].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[14].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[15]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[15].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[15].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[16]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[16].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[16].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[17]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[17].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[17].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[18]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[18].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[18].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[19]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[19].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[19].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[20]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[20].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[20].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[21]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[21].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[21].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[22]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[22].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[22].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[23]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getPreciTypeColor(
                          higherStationData[23].greaterAccumPrec
                        ),
                      }"
                      >{{ higherStationData[23].greaterAccumPrec }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      class="mt-1"
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Maior precipitação no dia
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template
              v-slot:[`body.append`]
              v-if="typeLocation == 'countie' && loadingForecast == false"
            >
              <tr>
                <td style="color: #558a80; background: #e7fdf5; height: 78px">
                  <span>Estação {{ filterSelected.location.name }} </span>
                </td>

                <td
                  class="text-end v-data-table__divider"
                  v-for="(data, i) in registeredDataItems"
                  :key="i"
                >
                  <span :style="{ color: getPreciTypeColor(data.accumPrec) }">
                    {{ data.accumPrec }}</span
                  >
                </td>
              </tr>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                :style="{
                  color: item.color,
                  background: item.background,
                  height: item.height,
                }"
              >
                {{
                  item.cityName
                    ? item.cityName
                    : daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template v-slot:[`item.accumPrec0`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec0) }"
                    >{{
                      typeof item.accumPrec0 != "undefined"
                        ? item.accumPrec0
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec0, 0, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec1`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec1) }"
                    >{{
                      typeof item.accumPrec1 != "undefined"
                        ? item.accumPrec1
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec1, 1, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec2`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec2) }"
                    >{{
                      typeof item.accumPrec2 != "undefined"
                        ? item.accumPrec2
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec2, 2, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec3`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec3) }"
                    >{{
                      typeof item.accumPrec5 != "undefined"
                        ? item.accumPrec3
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec3, 3, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec4`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec4) }"
                    >{{
                      typeof item.accumPrec4 != "undefined"
                        ? item.accumPrec4
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec4, 4, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec5`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec5) }"
                    >{{
                      typeof item.accumPrec5 != "undefined"
                        ? item.accumPrec5
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec5, 5, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec6`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec6) }"
                    >{{
                      typeof item.accumPrec6 != "undefined"
                        ? item.accumPrec6
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec6, 6, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec7`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec7) }"
                    >{{
                      typeof item.accumPrec7 != "undefined"
                        ? item.accumPrec7
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec7, 7, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.accumPrec8`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec8) }"
                    >{{
                      typeof item.accumPrec8 != "undefined"
                        ? item.accumPrec8
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec8, 8, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec9`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec9) }"
                    >{{
                      typeof item.accumPrec9 != "undefined"
                        ? item.accumPrec9
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(item.accumPrec9, 9, 'precipitation') &&
                      typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec10`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec10) }"
                    >{{
                      typeof item.accumPrec10 != "undefined"
                        ? item.accumPrec10
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec10,
                        10,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec11`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec11) }"
                    >{{
                      typeof item.accumPrec11 != "undefined"
                        ? item.accumPrec11
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec11,
                        11,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec12`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec12) }"
                    >{{
                      typeof item.accumPrec12 != "undefined"
                        ? item.accumPrec12
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec12,
                        12,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec13`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec13) }"
                    >{{
                      typeof item.accumPrec13 != "undefined"
                        ? item.accumPrec13
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec13,
                        13,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec14`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec14) }"
                    >{{
                      typeof item.accumPrec14 != "undefined"
                        ? item.accumPrec14
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec14,
                        14,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec15`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec15) }"
                    >{{
                      typeof item.accumPrec15 != "undefined"
                        ? item.accumPrec15
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec15,
                        15,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec16`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec16) }"
                    >{{
                      typeof item.accumPrec16 != "undefined"
                        ? item.accumPrec16
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec16,
                        16,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec17`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec17) }"
                    >{{
                      typeof item.accumPrec17 != "undefined"
                        ? item.accumPrec17
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec17,
                        17,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec18`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec18) }"
                    >{{
                      typeof item.accumPrec18 != "undefined"
                        ? item.accumPrec18
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec18,
                        18,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec19`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec19) }"
                    >{{
                      typeof item.accumPrec19 != "undefined"
                        ? item.accumPrec19
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec19,
                        19,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec20`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec20) }"
                    >{{
                      typeof item.accumPrec20 != "undefined"
                        ? item.accumPrec20
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec20,
                        20,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec21`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec21) }"
                    >{{
                      typeof item.accumPrec21 != "undefined"
                        ? item.accumPrec21
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec21,
                        21,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec22`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec22) }"
                    >{{
                      typeof item.accumPrec22 != "undefined"
                        ? item.accumPrec22
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec22,
                        22,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.accumPrec23`]="{ item }">
              <v-row dense>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getPreciTypeColor(item.accumPrec23) }"
                    >{{
                      typeof item.accumPrec23 != "undefined"
                        ? item.accumPrec23
                        : "-"
                    }}</span
                  >
                </v-col>
                <v-col cols="12" v-if="typeLocation != 'countie'">
                  <v-chip
                    pill
                    class="mt-0"
                    label
                    color="#E0F2F1"
                    text-color="#00A98C"
                    small
                    v-if="
                      getBiggestStation(
                        item.accumPrec23,
                        23,
                        'precipitation'
                      ) && typeof item.cityName != 'undefined'
                    "
                  >
                    Maior precipitação no dia
                  </v-chip>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="pt-5" id="temp">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon class="pr-1" x-small>
            icon-alertadis-temperature-three-quarter
          </v-icon>
          Temperatura (°C)

          <v-spacer> </v-spacer>
          <div class="legend-style">
            <span
              style="background: #136cba; color: #136cba"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #136cba"
              >Temperatura baixa</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #a5cd78; color: #a5cd78"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #a5cd78"
              >Temperatura normal</span
            >
          </div>

          <div class="legend-style">
            <span
              style="background: #9b1400; color: #9b1400"
              class="ellipse-legend"
            ></span>
            <span class="legend-title pt-0 pr-2" style="color: #9b1400"
              >Temperatura alta
            </span>
          </div>

          <v-btn icon small @click="changeToFullSreen('temp')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable @exportXLS="exportXLS('temp')"></MenuExportTable>
        </v-card-title>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == true"
        >
          Dados previstos e registrados de temperatura na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == false"
        >
          Dados previstos e registrados de temperatura na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == true"
        >
          Dados previstos e registrados de temperatura na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == false"
        >
          Dados previstos e registrados de temperatura na agência
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == true"
        >
          Dados previstos e registrados de temperatura em
          {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == false"
        >
          Dados previstos e registrados de temperatura em
          {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            v-if="daily == false"
            class="table-style"
            :headers="headersTemp"
            disable-pagination
            :items="forecastsDataItemsTemp"
            height="600px"
            id="predictionDataTable"
            :loading="loadingForecast"
            :group-by="typeLocation != 'countie' ? 'agroup' : []"
            fixed-header
            hide-default-footer
          >
            <template v-slot:[`item.runtime`]="{ item }">
              <td
                :style="{
                  color: item.color,
                  background: item.background,
                  height: item.height,
                }"
              >
                {{
                  item.cityName
                    ? item.cityName
                    : daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>
            <template
              v-slot:[`group.header`]="{ isOpen, toggle, group }"
              v-if="typeLocation != 'countie'"
            >
              <td
                style="color: #558a80; background: #e7fdf5; height: 78px"
                v-if="group"
              >
                <div class="d-flex">
                  <div class="pr-3">
                    <v-btn icon @click="toggle(!isOpen)">
                      <v-icon v-show="!isOpen" color="#558A80">
                        mdi-plus-circle-outline</v-icon
                      >
                      <v-icon v-show="isOpen" color="#558A80">
                        mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                  </div>

                  <v-divider vertical></v-divider>
                  <span> Dados registrado nas estações</span>
                </div>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[0]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[0].medTemp),
                      }"
                      >{{ higherStationData[0].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[1]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[1].medTemp),
                      }"
                      >{{ higherStationData[1].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[2]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[2].medTemp),
                      }"
                      >{{ higherStationData[2].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[3]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[3].medTemp),
                      }"
                      >{{ higherStationData[3].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[4]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[4].medTemp),
                      }"
                      >{{ higherStationData[4].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[5]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[5].medTemp),
                      }"
                      >{{ higherStationData[5].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[6]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[6].medTemp),
                      }"
                      >{{ higherStationData[6].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[7]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[7].medTemp),
                      }"
                      >{{ higherStationData[7].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[8]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[8].medTemp),
                      }"
                      >{{ higherStationData[8].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[9]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[9].medTemp),
                      }"
                      >{{ higherStationData[9].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[10]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[10].medTemp),
                      }"
                      >{{ higherStationData[10].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[11]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[11].medTemp),
                      }"
                      >{{ higherStationData[11].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[12]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[12].medTemp),
                      }"
                      >{{ higherStationData[12].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[13]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[13].medTemp),
                      }"
                      >{{ higherStationData[13].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[14]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[14].medTemp),
                      }"
                      >{{ higherStationData[14].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[15]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[15].medTemp),
                      }"
                      >{{ higherStationData[15].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[16]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[16].medTemp),
                      }"
                      >{{ higherStationData[16].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[17]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[17].medTemp),
                      }"
                      >{{ higherStationData[17].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[18]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[18].medTemp),
                      }"
                      >{{ higherStationData[18].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[19]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[19].medTemp),
                      }"
                      >{{ higherStationData[19].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[20]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[20].medTemp),
                      }"
                      >{{ higherStationData[20].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[21]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[21].medTemp),
                      }"
                      >{{ higherStationData[21].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[22]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[22].medTemp),
                      }"
                      >{{ higherStationData[22].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[23]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="12">
                    <span
                      :style="{
                        color: getTempTypeColor(higherStationData[23].medTemp),
                      }"
                      >{{ higherStationData[23].medTemp }}</span
                    >
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                    >
                      Temperatura média
                    </v-chip>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template
              v-slot:[`body.append`]
              v-if="typeLocation == 'countie' && loadingForecast == false"
            >
              <tr>
                <td style="color: #558a80; background: #e7fdf5; height: 78px">
                  <span>Estação {{ filterSelected.location.name }} </span>
                </td>

                <td
                  class="text-end v-data-table__divider"
                  v-for="(data, i) in registeredDataItems"
                  :key="i"
                >
                  <span :style="{ color: getTempTypeColor(data.meanTemp) }">
                    {{ data.meanTemp }}</span
                  >
                </td>
              </tr>
            </template>

            <template v-slot:[`item.tempMed0`]="{ item }">
              <v-row no-gutters>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed0) }"
                    >{{
                      typeof item.tempMed0 != "undefined" ? item.tempMed0 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed0, 0, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed1`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed1) }"
                    >{{
                      typeof item.tempMed1 != "undefined" ? item.tempMed1 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed1, 1, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed2`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed2) }"
                    >{{
                      typeof item.tempMed2 != "undefined" ? item.tempMed2 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed2, 2, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed3`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed3) }"
                    >{{
                      typeof item.tempMed3 != "undefined" ? item.tempMed3 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed3, 3, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed4`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed4) }"
                    >{{
                      typeof item.tempMed4 != "undefined" ? item.tempMed4 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed4, 4, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed5`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed5) }"
                    >{{
                      typeof item.tempMed5 != "undefined" ? item.tempMed5 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed5, 5, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed6`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed6) }"
                    >{{
                      typeof item.tempMed6 != "undefined" ? item.tempMed6 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed6, 6, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed7`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed7) }"
                    >{{
                      typeof item.tempMed7 != "undefined" ? item.tempMed7 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed7, 7, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed8`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed8) }"
                    >{{
                      typeof item.tempMed8 != "undefined" ? item.tempMed8 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed8, 8, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed9`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed9) }"
                    >{{
                      typeof item.tempMed9 != "undefined" ? item.tempMed9 : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed9, 9, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed10`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed10) }"
                    >{{
                      typeof item.tempMed10 != "undefined"
                        ? item.tempMed10
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed10, 10, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed11`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed11) }"
                    >{{
                      typeof item.tempMed11 != "undefined"
                        ? item.tempMed11
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed11, 11, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed12`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed12) }"
                    >{{
                      typeof item.tempMed12 != "undefined"
                        ? item.tempMed12
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed12, 12, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed13`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed13) }"
                    >{{
                      typeof item.tempMed13 != "undefined"
                        ? item.tempMed13
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed13, 13, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed14`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed14) }"
                    >{{
                      typeof item.tempMed14 != "undefined"
                        ? item.tempMed14
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed14, 14, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed15`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed15) }"
                    >{{
                      typeof item.tempMed15 != "undefined"
                        ? item.tempMed15
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed15, 15, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed16`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed16) }"
                    >{{
                      typeof item.tempMed16 != "undefined"
                        ? item.tempMed16
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed16, 16, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed17`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed17) }"
                    >{{
                      typeof item.tempMed17 != "undefined"
                        ? item.tempMed17
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed17, 17, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed18`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed18) }"
                    >{{
                      typeof item.tempMed18 != "undefined"
                        ? item.tempMed18
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed18, 18, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed19`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed19) }"
                    >{{
                      typeof item.tempMed19 != "undefined"
                        ? item.tempMed19
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed19, 19, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed20`]="{ item }">
              <v-row no-gutters>
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed20) }"
                    >{{
                      typeof item.tempMed20 != "undefined"
                        ? item.tempMed20
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed20, 20, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMed21`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed21) }"
                    >{{
                      typeof item.tempMed21 != "undefined"
                        ? item.tempMed21
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed21, 21, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed22`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed22) }"
                    >{{
                      typeof item.tempMed22 != "undefined"
                        ? item.tempMed22
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed22, 22, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMed23`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="12">
                  <span
                    class="item-style text-end"
                    :style="{ color: getTempTypeColor(item.tempMed23) }"
                    >{{
                      typeof item.tempMed22 != "undefined"
                        ? item.tempMed22
                        : "-"
                    }}</span
                  >

                  <v-col
                    cols="12"
                    class="pt-6"
                    v-if="typeLocation != 'countie'"
                  >
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      small
                      v-if="
                        getBiggestStation(item.tempMed23, 23, 'tempMed') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Menor Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <v-data-table
            v-if="daily == true"
            class="table-style"
            :headers="headersTemp"
            hide-default-footer
            disable-pagination
            :items="forecastsDataItemsTemp"
            height="600px"
            id="predictionDataTable"
            :loading="loadingForecast"
            :group-by="typeLocation != 'countie' ? 'agroup' : []"
            fixed-header
          >
            <template #header>
              <tr>
                <th
                  v-for="(h, i) in headers"
                  :key="i"
                  :class="createStyleHeader(i)"
                >
                  <div v-if="i != 0">
                    <span class="pr-16 header-sub-style">MIN</span>
                    <span class="header-sub-style pr-4">MAX</span>
                  </div>
                </th>
              </tr>
            </template>

            <template
              v-slot:[`group.header`]="{ isOpen, toggle, group }"
              v-if="typeLocation != 'countie'"
            >
              <td
                style="color: #558a80; background: #e7fdf5; height: 78px"
                v-if="group"
              >
                <div class="d-flex">
                  <div class="pr-3">
                    <v-btn icon @click="toggle(!isOpen)">
                      <v-icon v-show="!isOpen" color="#558A80">
                        mdi-plus-circle-outline</v-icon
                      >
                      <v-icon v-show="isOpen" color="#558A80">
                        mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                  </div>

                  <v-divider vertical></v-divider>
                  <span> Dados registrado nas estações</span>
                </div>
              </td>

              <td
                class="item-style text-end v-data-table__divider"
                v-if="group && higherStationData[0]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[0].minTemp),
                        }"
                        >{{ higherStationData[0].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[0].maxTemp),
                        }"
                        >{{ higherStationData[0].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[1]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[1].minTemp),
                        }"
                        >{{ higherStationData[1].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[1].maxTemp),
                        }"
                        >{{ higherStationData[1].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[2]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[2].minTemp),
                        }"
                        >{{ higherStationData[2].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[2].maxTemp),
                        }"
                        >{{ higherStationData[2].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[3]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[3].minTemp),
                        }"
                        >{{ higherStationData[3].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[3].maxTemp),
                        }"
                        >{{ higherStationData[3].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[4]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[4].minTemp),
                        }"
                        >{{ higherStationData[4].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[4].maxTemp),
                        }"
                        >{{ higherStationData[4].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[5]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[5].minTemp),
                        }"
                        >{{ higherStationData[5].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[5].maxTemp),
                        }"
                        >{{ higherStationData[5].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[6]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[6].minTemp),
                        }"
                        >{{ higherStationData[6].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[6].maxTemp),
                        }"
                        >{{ higherStationData[6].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[7]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[7].minTemp),
                        }"
                        >{{ higherStationData[7].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[7].maxTemp),
                        }"
                        >{{ higherStationData[7].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[8]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[8].minTemp),
                        }"
                        >{{ higherStationData[8].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[8].maxTemp),
                        }"
                        >{{ higherStationData[8].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[9]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[9].minTemp),
                        }"
                        >{{ higherStationData[9].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(higherStationData[9].maxTemp),
                        }"
                        >{{ higherStationData[9].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[10]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[10].minTemp
                          ),
                        }"
                        >{{ higherStationData[10].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[10].maxTemp
                          ),
                        }"
                        >{{ higherStationData[10].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[11]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[11].minTemp
                          ),
                        }"
                        >{{ higherStationData[11].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[11].maxTemp
                          ),
                        }"
                        >{{ higherStationData[11].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[12]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[12].minTemp
                          ),
                        }"
                        >{{ higherStationData[12].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[12].maxTemp
                          ),
                        }"
                        >{{ higherStationData[12].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[13]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[13].minTemp
                          ),
                        }"
                        >{{ higherStationData[13].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[13].maxTemp
                          ),
                        }"
                        >{{ higherStationData[13].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>
              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[14]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[14].minTemp
                          ),
                        }"
                        >{{ higherStationData[14].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[14].maxTemp
                          ),
                        }"
                        >{{ higherStationData[14].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[15]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[15].minTemp
                          ),
                        }"
                        >{{ higherStationData[15].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[15].maxTemp
                          ),
                        }"
                        >{{ higherStationData[15].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[16]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[16].minTemp
                          ),
                        }"
                        >{{ higherStationData[16].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[16].maxTemp
                          ),
                        }"
                        >{{ higherStationData[16].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[17]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[17].minTemp
                          ),
                        }"
                        >{{ higherStationData[17].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[17].maxTemp
                          ),
                        }"
                        >{{ higherStationData[17].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[18]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[18].minTemp
                          ),
                        }"
                        >{{ higherStationData[18].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[18].maxTemp
                          ),
                        }"
                        >{{ higherStationData[18].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[19]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[19].minTemp
                          ),
                        }"
                        >{{ higherStationData[19].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[19].maxTemp
                          ),
                        }"
                        >{{ higherStationData[19].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[20]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[20].minTemp
                          ),
                        }"
                        >{{ higherStationData[20].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[20].maxTemp
                          ),
                        }"
                        >{{ higherStationData[20].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[21]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[21].minTemp
                          ),
                        }"
                        >{{ higherStationData[21].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[21].maxTemp
                          ),
                        }"
                        >{{ higherStationData[21].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[22]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[22].minTemp
                          ),
                        }"
                        >{{ higherStationData[22].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[22].maxTemp
                          ),
                        }"
                        >{{ higherStationData[22].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>

              <td
                class="text-end item-style v-data-table__divider"
                v-if="group && higherStationData[23]"
                style="background: #151723"
              >
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[23].minTemp
                          ),
                        }"
                        >{{ higherStationData[23].minTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        class="pr-2"
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>

                  <v-col cols="6">
                    <v-col cols="12">
                      <span
                        :style="{
                          color: getTempTypeColor(
                            higherStationData[23].maxTemp
                          ),
                        }"
                        >{{ higherStationData[23].maxTemp }}</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                      >
                        Maior Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template v-slot:[`item.runtime`]="{ item }">
              <td
                :style="{
                  color: item.color,
                  background: item.background,
                  height: item.height,
                }"
              >
                {{
                  item.cityName
                    ? item.cityName
                    : daily == true
                    ? moment(item.runtime).utc().format("ddd. DD/MM/YYYY")
                    : moment(item.runtime).utc().format("ddd. DD/MM/YYYY HH:mm")
                }}
              </td>
            </template>

            <template
              v-slot:[`body.append`]
              v-if="typeLocation == 'countie' && loadingForecast == false"
            >
              <tr>
                <td style="color: #558a80; background: #e7fdf5; height: 78px">
                  <span>Estação {{ filterSelected.location.name }} </span>
                </td>

                <td
                  class="text-end v-data-table__divider"
                  v-for="(data, i) in registeredDataItems"
                  :key="i"
                >
                  <span
                    class="item-style pr-16"
                    :style="{ color: getTempTypeColor(data.maxTemp) }"
                  >
                    {{ data.maxTemp }}</span
                  >
                  <span
                    class="item-style"
                    :style="{ color: getTempTypeColor(data.minTemp) }"
                  >
                    {{ data.minTemp }}</span
                  >
                </td>
              </tr>
            </template>

            <template v-slot:[`item.tempMin0`]="{ item }">
              <v-row no-gutters class="d-flex item-style">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin0) }"
                      >{{
                        typeof item.tempMin0 != "undefined"
                          ? item.tempMin0
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="pr-12"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax0, 0, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax0) }"
                      >{{
                        typeof item.tempMax0 != "undefined"
                          ? item.tempMax0
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax0, 0, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin1`]="{ item }">
              <v-row no-gutters class="d-flex item-style">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin0) }"
                      >{{
                        typeof item.tempMin0 != "undefined"
                          ? item.tempMin0
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax0, 0, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax1) }"
                      >{{
                        typeof item.tempMax1 != "undefined"
                          ? item.tempMax1
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax1, 1, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin2`]="{ item }">
              <v-row no-gutters class="d-flex item-style">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin2) }"
                      >{{
                        typeof item.tempMin2 != "undefined"
                          ? item.tempMin2
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax2, 2, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax2) }"
                      >{{
                        typeof item.tempMax2 != "undefined"
                          ? item.tempMax2
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax2, 2, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin3`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin3) }"
                      >{{
                        typeof item.tempMin3 != "undefined"
                          ? item.tempMin2
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax3, 3, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax3) }"
                      >{{
                        typeof item.tempMax3 != "undefined"
                          ? item.tempMax3
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax3, 3, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin4`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin4) }"
                      >{{
                        typeof item.tempMin4 != "undefined"
                          ? item.tempMin4
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax4, 4, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax4) }"
                      >{{
                        typeof item.tempMax4 != "undefined"
                          ? item.tempMax4
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax4, 4, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin5`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin5) }"
                      >{{
                        typeof item.tempMin5 != "undefined"
                          ? item.tempMin5
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax5, 4, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax5) }"
                      >{{
                        typeof item.tempMax5 != "undefined"
                          ? item.tempMax5
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax5, 5, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin6`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin6) }"
                      >{{
                        typeof item.tempMin6 != "undefined"
                          ? item.tempMin6
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax6, 4, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax6) }"
                      >{{
                        typeof item.tempMax6 != "undefined"
                          ? item.tempMax6
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax6, 6, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.tempMin7`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin7) }"
                      >{{
                        typeof item.tempMin7 != "undefined"
                          ? item.tempMin7
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMin7, 7, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax7) }"
                      >{{
                        typeof item.tempMax7 != "undefined"
                          ? item.tempMax7
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax7, 6, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin8`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin8) }"
                      >{{
                        typeof item.tempMin8 != "undefined"
                          ? item.tempMin8
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax8, 4, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax8) }"
                      >{{
                        typeof item.tempMax8 != "undefined"
                          ? item.tempMax8
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax8, 8, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin9`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin9) }"
                      >{{
                        typeof item.tempMin9 != "undefined"
                          ? item.tempMin9
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMin9, 9, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax9) }"
                      >{{
                        typeof item.tempMax9 != "undefined"
                          ? item.tempMax9
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax9, 9, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin10`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin10) }"
                      >{{
                        typeof item.tempMin10 != "undefined"
                          ? item.tempMin10
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax10, 10, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax10) }"
                      >{{
                        typeof item.tempMax10 != "undefined"
                          ? item.tempMax10
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax10, 10, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin11`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin11) }"
                      >{{
                        typeof item.tempMin11 != "undefined"
                          ? item.tempMin11
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax11, 11, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax11) }"
                      >{{
                        typeof item.tempMax11 != "undefined"
                          ? item.tempMax11
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax11, 11, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin12`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin12) }"
                      >{{
                        typeof item.tempMin12 != "undefined"
                          ? item.tempMin12
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax12, 12, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax12) }"
                      >{{
                        typeof item.tempMax12 != "undefined"
                          ? item.tempMax12
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax12, 12, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin13`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin13) }"
                      >{{
                        typeof item.tempMin13 != "undefined"
                          ? item.tempMin13
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax13, 13, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax13) }"
                      >{{
                        typeof item.tempMax13 != "undefined"
                          ? item.tempMax13
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax13, 13, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin14`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin14) }"
                      >{{
                        typeof item.tempMin14 != "undefined"
                          ? item.tempMin14
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax14, 14, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax14) }"
                      >{{
                        typeof item.tempMax14 != "undefined"
                          ? item.tempMax14
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax14, 14, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin15`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin15) }"
                      >{{
                        typeof item.tempMin15 != "undefined"
                          ? item.tempMin15
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax15, 15, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax15) }"
                      >{{
                        typeof item.tempMax15 != "undefined"
                          ? item.tempMax15
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax15, 15, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin16`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin16) }"
                      >{{
                        typeof item.tempMin16 != "undefined"
                          ? item.tempMin16
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax16, 16, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax16) }"
                      >{{
                        typeof item.tempMax16 != "undefined"
                          ? item.tempMax16
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax16, 16, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin17`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin17) }"
                      >{{
                        typeof item.tempMin17 != "undefined"
                          ? item.tempMin17
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax17, 17, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax17) }"
                      >{{
                        typeof item.tempMax17 != "undefined"
                          ? item.tempMax17
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax17, 17, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin18`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin18) }"
                      >{{
                        typeof item.tempMin18 != "undefined"
                          ? item.tempMin18
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax18, 18, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax18) }"
                      >{{
                        typeof item.tempMax18 != "undefined"
                          ? item.tempMax18
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax18, 18, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin19`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin19) }"
                      >{{
                        typeof item.tempMin19 != "undefined"
                          ? item.tempMin19
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax19, 19, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax19) }"
                      >{{
                        typeof item.tempMax19 != "undefined"
                          ? item.tempMax19
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax19, 19, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin20`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin20) }"
                      >{{
                        typeof item.tempMin20 != "undefined"
                          ? item.tempMin20
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax20, 20, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax20) }"
                      >{{
                        typeof item.tempMax20 != "undefined"
                          ? item.tempMax20
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax20, 20, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin21`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin21) }"
                      >{{
                        typeof item.tempMin21 != "undefined"
                          ? item.tempMin21
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax21, 21, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax21) }"
                      >{{
                        typeof item.tempMax21 != "undefined"
                          ? item.tempMax21
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax21, 21, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin22`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin22) }"
                      >{{
                        typeof item.tempMin22 != "undefined"
                          ? item.tempMin22
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax22, 22, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax22) }"
                      >{{
                        typeof item.tempMax22 != "undefined"
                          ? item.tempMax22
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax22, 22, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.tempMin23`]="{ item }">
              <v-row no-gutters class="d-flex">
                <v-col cols="6">
                  <v-col cols="12">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMin23) }"
                      >{{
                        typeof item.tempMin23 != "undefined"
                          ? item.tempMin23
                          : "-"
                      }}</span
                    >

                    <v-col
                      cols="12"
                      class="pt-6"
                      v-if="typeLocation != 'countie'"
                    >
                      <v-chip
                        pill
                        label
                        color="#E0F2F1"
                        text-color="#00A98C"
                        class="mx-10"
                        x-small
                        v-if="
                          getBiggestStation(item.tempMax23, 23, 'temp') &&
                          typeof item.cityName != 'undefined'
                        "
                      >
                        Menor Temperatura
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <span
                      class="item-style"
                      :style="{ color: getTempTypeColor(item.tempMax23) }"
                      >{{
                        typeof item.tempMax23 != "undefined"
                          ? item.tempMax23
                          : "-"
                      }}</span
                    >
                  </v-col>

                  <v-col cols="12" v-if="typeLocation != 'countie'">
                    <v-chip
                      pill
                      label
                      color="#E0F2F1"
                      text-color="#00A98C"
                      class="mx-7"
                      x-small
                      v-if="
                        getBiggestStation(item.tempMax23, 23, 'temp') &&
                        typeof item.cityName != 'undefined'
                      "
                    >
                      Maior Temperatura
                    </v-chip>
                  </v-col>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row class="pt-5" id="lightning">
      <v-card class="card-style">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-bolt </v-icon>
          Raios
          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('lightning')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable
            @exportXLS="exportXLS('lightning')"
          ></MenuExportTable>
        </v-card-title>
        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == true"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'regional' && daily == false"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == true"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'agency' && daily == false"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.id }} {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == true"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.name }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="typeLocation == 'countie' && daily == false"
        >
          Dados registrados de raios na regional
          {{ filterSelected.location.name }} -
          {{ moment(hourlyDataFilter[0]).utc().format("DD/MM/YYYY") }} das
          {{ moment(hourlyDataFilter[0]).utc().format("HH:mm") }}
          às
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("HH:mm")
          }}
        </v-card-subtitle>

        <v-card-text>
          <v-data-table
            class="table-style"
            :headers="headersLightning"
            hide-default-footer
            disable-pagination
            :items="predictedDataItemsLightning"
            id="predictionDataTable"
            :loading="loadingLightning"
            fixed-header
          >
            <template v-slot:[`item.registeredData`]="{ item }">
              <td style="color: #558a80; background: #e7fdf5; height: 78px">
                {{ item.registeredData }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="pt-5" id="weatherAlerts">
      <v-card v-if="typeLocation != 'regional'">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-thunderstorm-sun </v-icon>
          Alertas Meteorológicos
        </v-card-title>
        <v-card-text>
          <div class="alert-weather">
            <div class="d-flex align-center">
              <v-icon color="#E67E22">icon-alertadis-info-circle</v-icon>
            </div>

            <div>
              <div class="pl-2 info-alert-title d-flex align-center">
                Para visualizar os alertas meteorológicos selecione uma regional
              </div>
              <div class="pl-2 pt-2 info-alert-subtitle d-flex align-center">
                Os alertas meteorológicos são emitidos por regional, então não é
                possível visualizá-los no filtro por agência ou município.
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="card-style" v-if="typeLocation == 'regional'">
        <v-card-title class="card-title">
          <v-icon x-small> icon-alertadis-thunderstorm-sun </v-icon>
          Alertas Meteorológicos

          <v-spacer> </v-spacer>
          <v-btn icon small @click="changeToFullSreen('weatherAlerts')">
            <v-icon color="#F99741"> mdi-fullscreen</v-icon>
          </v-btn>
          <MenuExportTable
            @exportXLS="exportXLS('weatherAlerts')"
          ></MenuExportTable>
        </v-card-title>

        <v-card-subtitle
          class="card-subtitle"
          v-if="!loadingAlert && daily == true"
        >
          Alertas previstos na regional
          {{ filterSelected.location.fullname }} -
          {{ moment(dailyDataFilter[0]).format("DD/MM/YYYY") }}
          a
          {{
            moment(dailyDataFilter[dailyDataFilter.length - 1]).format(
              "DD/MM/YYYY"
            )
          }}
        </v-card-subtitle>

        <v-card-subtitle
          class="card-subtitle"
          v-if="!loadingAlert && daily == false"
        >
          Alertas previstos na regional
          {{ filterSelected.location.fullname }} -
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .format("DD/MM/YYYY")
          }}
          a
          {{
            moment(hourlyDataFilter[hourlyDataFilter.length - 1])
              .utc()
              .add(1, "days")
              .format("DD/MM/YYYY")
          }}
        </v-card-subtitle>
        <v-card-text v-if="loadingAlert">
          <lottie
            class="loading-animation"
            :options="alertaDisLoadingStationData"
            :height="120"
            :width="100"
          />
        </v-card-text>

        <v-card-text v-if="!loadingAlert && weatherTableData.length == 0">
          <div class="alert-weather">
            <div class="d-flex align-center">
              <v-icon color="#E67E22"
                >icon-alertadis-exclamation-triangle</v-icon
              >
            </div>
            <div>
              <div class="pl-2 pt-1 info-alert-subtitle d-flex align-center">
                Não há alertas meteorológicos no período selecionado.
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-text v-if="!loadingAlert && weatherTableData.length > 0">
          <v-data-table
            class="table-style"
            :headers="headersAlert"
            :items="weatherAlertsItems"
            hide-default-footer
            disable-pagination
            height="299px"
            id="predictionDataTable"
            fixed-header
          >
            <template v-slot:[`item.typeData`]="{ item }">
              <td
                style="
                  color: #b4dbff;
                  background: rgba(75, 166, 251, 0.1);
                  height: 78px;
                  width: 180px;
                "
              >
                {{ item.typeData }}
              </td>
            </template>

            <template v-slot:[`item.column0`]="{ item }">
              <span :style="{ color: intensityColor(item.column0) }">
                {{ item.column0 }}
              </span>
            </template>
            <template v-slot:[`item.column1`]="{ item }">
              <span :style="{ color: intensityColor(item.column1) }">
                {{ item.column1 }}
              </span>
            </template>

            <template v-slot:[`item.column2`]="{ item }">
              <span :style="{ color: intensityColor(item.column2) }">
                {{ item.column2 }}
              </span>
            </template>
            <template v-slot:[`item.column3`]="{ item }">
              <span :style="{ color: intensityColor(item.column3) }">
                {{ item.column3 }}
              </span>
            </template>
            <template v-slot:[`item.column4`]="{ item }">
              <span :style="{ color: intensityColor(item.column4) }">
                {{ item.column4 }}
              </span>
            </template>
            <template v-slot:[`item.column5`]="{ item }">
              <span :style="{ color: intensityColor(item.column5) }">
                {{ item.column5 }}
              </span>
            </template>
            <template v-slot:[`item.column6`]="{ item }">
              <span :style="{ color: intensityColor(item.column6) }">
                {{ item.column6 }}
              </span>
            </template>
            <template v-slot:[`item.column7`]="{ item }">
              <span :style="{ color: intensityColor(item.column7) }">
                {{ item.column7 }}
              </span>
            </template>
            <template v-slot:[`item.column8`]="{ item }">
              <span :style="{ color: intensityColor(item.column8) }">
                {{ item.column8 }}
              </span>
            </template>
            <template v-slot:[`item.column9`]="{ item }">
              <span :style="{ color: intensityColor(item.column9) }">
                {{ item.column9 }}
              </span>
            </template>

            <template v-slot:[`item.column10`]="{ item }">
              <span :style="{ color: intensityColor(item.column10) }">
                {{ item.column10 }}
              </span>
            </template>

            <template v-slot:[`item.column11`]="{ item }">
              <span :style="{ color: intensityColor(item.column11) }">
                {{ item.column11 }}
              </span>
            </template>
            <template v-slot:[`item.column12`]="{ item }">
              <span :style="{ color: intensityColor(item.column12) }">
                {{ item.column12 }}
              </span>
            </template>
            <template v-slot:[`item.column13`]="{ item }">
              <span :style="{ color: intensityColor(item.column13) }">
                {{ item.column13 }}
              </span>
            </template>
            <template v-slot:[`item.column14`]="{ item }">
              <span :style="{ color: intensityColor(item.column14) }">
                {{ item.column14 }}
              </span>
            </template>
            <template v-slot:[`item.column15`]="{ item }">
              <span :style="{ color: intensityColor(item.column15) }">
                {{ item.column15 }}
              </span>
            </template>
            <template v-slot:[`item.column16`]="{ item }">
              <span :style="{ color: intensityColor(item.column16) }">
                {{ item.column1 }}
              </span>
            </template>
            <template v-slot:[`item.column17`]="{ item }">
              <span :style="{ color: intensityColor(item.column17) }">
                {{ item.column17 }}
              </span>
            </template>
            <template v-slot:[`item.column18`]="{ item }">
              <span :style="{ color: intensityColor(item.column18) }">
                {{ item.column18 }}
              </span>
            </template>

            <template v-slot:[`item.column19`]="{ item }">
              <span :style="{ color: intensityColor(item.column19) }">
                {{ item.column19 }}
              </span>
            </template>

            <template v-slot:[`item.column20`]="{ item }">
              <span :style="{ color: intensityColor(item.column20) }">
                {{ item.column20 }}
              </span>
            </template>

            <template v-slot:[`item.column21`]="{ item }">
              <span :style="{ color: intensityColor(item.column21) }">
                {{ item.column21 }}
              </span>
            </template>
            <template v-slot:[`item.column22`]="{ item }">
              <span :style="{ color: intensityColor(item.column22) }">
                {{ item.column22 }}
              </span>
            </template>

            <template v-slot:[`item.column23`]="{ item }">
              <span :style="{ color: intensityColor(item.column23) }">
                {{ item.column23 }}
              </span>
            </template>

            <template v-slot:[`item.column24`]="{ item }">
              <span :style="{ color: intensityColor(item.column24) }">
                {{ item.column24 }}
              </span>
            </template>
            <template v-slot:[`item.column25`]="{ item }">
              <span :style="{ color: intensityColor(item.column25) }">
                {{ item.column25 }}
              </span>
            </template>

            <template v-slot:[`item.column26`]="{ item }">
              <span :style="{ color: intensityColor(item.column26) }">
                {{ item.column26 }}
              </span>
            </template>

            <template v-slot:[`item.column27`]="{ item }">
              <span :style="{ color: intensityColor(item.column27) }">
                {{ item.column26 }}
              </span>
            </template>

            <template v-slot:[`item.column28`]="{ item }">
              <span :style="{ color: intensityColor(item.column28) }">
                {{ item.column28 }}
              </span>
            </template>
            <template v-slot:[`item.column29`]="{ item }">
              <span :style="{ color: intensityColor(item.column29) }">
                {{ item.column29 }}
              </span>
            </template>

            <template v-slot:[`item.column30`]="{ item }">
              <span :style="{ color: intensityColor(item.column30) }">
                {{ item.column30 }}
              </span>
            </template>
            <template v-slot:[`item.column31`]="{ item }">
              <span :style="{ color: intensityColor(item.column31) }">
                {{ item.column31 }}
              </span>
            </template>

            <template v-slot:[`item.column32`]="{ item }">
              <span :style="{ color: intensityColor(item.column32) }">
                {{ item.column32 }}
              </span>
            </template>

            <template v-slot:[`item.column33`]="{ item }">
              <span :style="{ color: intensityColor(item.column33) }">
                {{ item.column33 }}
              </span>
            </template>

            <template v-slot:[`item.column34`]="{ item }">
              <span :style="{ color: intensityColor(item.column34) }">
                {{ item.column34 }}
              </span>
            </template>

            <template v-slot:[`item.column35`]="{ item }">
              <span :style="{ color: intensityColor(item.column35) }">
                {{ item.column35 }}
              </span>
            </template>

            <template v-slot:[`item.column36`]="{ item }">
              <span :style="{ color: intensityColor(item.column36) }">
                {{ item.column36 }}
              </span>
            </template>

            <template v-slot:[`item.column37`]="{ item }">
              <span :style="{ color: intensityColor(item.column37) }">
                {{ item.column37 }}
              </span>
            </template>

            <template v-slot:[`item.column38`]="{ item }">
              <span :style="{ color: intensityColor(item.column38) }">
                {{ item.column38 }}
              </span>
            </template>

            <template v-slot:[`item.column39`]="{ item }">
              <span :style="{ color: intensityColor(item.column39) }">
                {{ item.column39 }}
              </span>
            </template>

            <template v-slot:[`item.column40`]="{ item }">
              <span :style="{ color: intensityColor(item.column40) }">
                {{ item.column40 }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>


<script>
import moment from "moment";

import { mapGetters } from "vuex";

import MenuExportTable from "@/components/historical/MenuExportTable.vue";
import * as xlsx from "xlsx";
import Lottie from "@/core/component/lottie.vue";
import alertaDisLoadingLottie from "@/assets/loadingAlertaDisAnimation.json";

export default {
  components: {
    MenuExportTable,
    Lottie,
  },

  props: {
    daily: {
      type: Boolean,
      required: true,
    },
    dailyPeriods: {
      type: Object,
      required: true,
    },
    hourlyPeriods: {
      type: Array,
      required: true,
    },
    typeLocation: {
      type: String,
      required: true,
    },
    filterSelected: {
      type: Object,
      required: true,
    },

    dailyPeriodsTable: {
      type: Object,
      required: true,
    },
    dailyDataFilter: {
      type: Array,
      required: true,
    },
    hourlyPeriodsTable: {
      type: Array,
      required: true,
    },
    hourlyDataFilter: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    selectedDaily: [],
    selectedHour: [],
    hourlyInDailyPeriodsSelected: { id: 0, name: "00:00" },
    headers: [],
    predictedData: [],
    predictedDataItemsRegional: [],
    predictedDataItemsRegionalCopy: [],
    predictedDataItemsAgency: [],
    predictedDataItemsAgencyCopy: [],
    predictedDataItemsCountie: [],
    predictedDataItemsCountieCopy: [],
    predictedDataItemsAlert: [],
    predictedDataItemsLightning: [],
    forecastsDataItemsWind: [],
    forecastsDataItemsWindCopy: [],
    forecastsDataItemsTemp: [],
    forecastsDataItemsTempCopy: [],
    forecastsDataItemsPrecip: [],
    forecastsDataItemsPrecipCopy: [],
    registeredDataItems: [],
    dataRecordedStations: [],
    higherStationData: [],
    loading: false,
    loadingLightning: false,
    loadingForecast: false,
    headersLightning: [],
    headersWindGust: [],
    headersPreci: [],
    headersTemp: [],
    weatherAlertsItems: [],
    forecastsDataItems: [],
    forecastsDataItemsCopy: [],
    headersAlert: [],
    alertaDisLoadingStationData: {
      animationData: alertaDisLoadingLottie,
    },
    loadingAlert: false,
    dataLightning: [],
    dataweatherAlerts: [],
    forecastDataItemsRegional: [],
    forecastDataItemsRegionalCopy: [],
    loadingRegional: false,
    dataRegional: [],
  }),

  created() {
    this.selectedDaily = [...this.dailyPeriodsTable.dates];
    this.selectedHour = [...this.hourlyPeriodsTable];
  },
  async mounted() {
    this.createHeadersTable();
    this.$store.dispatch("fetchListCities");
    await this.changeFilter();
  },
  watch: {
    filterSelected: {
      deep: true,
      handler(value) {
        if (value) {
          this.selectedDaily = [...this.dailyPeriodsTable.dates];
          this.selectedHour = [...this.hourlyPeriodsTable];
        }
      },
    },

    typeLocation: {
      deep: true,
      handler(value) {
        if (value) {
          //  this.changeFilter();
        }
      },
    },

    dailyDataFilter: {
      deep: true,
      handler(value) {
        if (value) {
          this.createHeadersTable();
          this.changeFilter();
        }
      },
    },

    hourlyDataFilter: {
      deep: true,
      handler(value) {
        if (value) {
          this.createHeadersTable();
          this.changeFilter();
        }
      },
    },
  },

  computed: {
    ...mapGetters([
      "historicalCountieData",
      "weatherData",
      "recordedDataFromTelmetryStations",
      "lightningCountData",
      "historicalRegionalData",
      "historicalAgencyQtdeUc",
      "historicalAgencyData",
      "historicalFullData",
      "historicalFullRegional",
      "historicalRegionalQtdeUc",
      "historicalForecastsData",
      "listCities",
      "hsitoricalRegionalCitiesSummary",
      "weatherAgenciesOnAlertsData",
      "weatherTableData",
    ]),

    forecastDate() {
      return `Data das previsões para os dias selecionados `;
    },

    forecastTime() {
      return `Data e hora das previsões para os dias selecionados `;
    },
  },

  methods: {
    changeForecast() {
      if (this.typeLocation == "regional") {
        this.predictedDataItemsRegional = [];

        this.predictedDataItemsRegionalCopy.forEach((el) => {
          this.selectedDaily.forEach((e) => {
            const runtime = moment(el.runtime).utc().format("YYYY-MM-DD");
            const date = moment(e.date).utc().format("YYYY-MM-DD");
            if (moment(runtime).isSame(date)) {
              this.predictedDataItemsRegional.push(el);
            }
          });
        });
        this.forecastDataItemsRegional = [];
        this.forecastDataItemsRegionalCopy.forEach((el) => {
          this.selectedDaily.forEach((e) => {
            const runtime = moment(el.runtime).utc().format("YYYY-MM-DD");
            const date = moment(e.date).utc().format("YYYY-MM-DD");
            if (moment(runtime).isSame(date)) {
              this.forecastDataItemsRegional.push(el);
            }
          });
        });
        this.forecastsDataItemsWind = [];
        this.forecastsDataItemsWindCopy.forEach((el) => {
          this.selectedDaily.forEach((e) => {
            const runtime = el.cityName
              ? null
              : moment(el.runtime).utc().format("YYYY-MM-DD");
            const date = moment(e.date).utc().format("YYYY-MM-DD");
            if (moment(runtime).isSame(date)) {
              this.forecastsDataItemsWind.push(el);
            }

            if (runtime == null) {
              this.forecastsDataItemsWind.push(el);
            }
          });
        });

        this.forecastsDataItemsPrecip = [];
        this.forecastsDataItemsPrecipCopy.forEach((el) => {
          this.selectedDaily.forEach((e) => {
            const runtime = el.cityName
              ? null
              : moment(el.runtime).utc().format("YYYY-MM-DD");
            const date = moment(e.date).utc().format("YYYY-MM-DD");
            if (moment(runtime).isSame(date)) {
              this.forecastsDataItemsPrecip.push(el);
            }

            if (runtime == null) {
              this.forecastsDataItemsPrecip.push(el);
            }
          });
        });
      }
    },

    isSelectedDaily(item) {
      return this.selectedDaily.some((el) => el.id === item.id);
    },
    toggleItemHour(item) {
      if (this.selectedHour.some((el) => el.id === item.id)) {
        if (this.selectedHour.length > 1) {
          this.removeHour(item);
        }
      } else {
        this.selectedHour.push(item);
      }
      if (this.typeLocation == "regional") {
        this.fetchForecastData();
        this.fetchDataTableRegionals();
        this.fetchDataTableRegional();

        return;
      }
      if (this.typeLocation == "agency") {
        this.fetchDataTableAgency();
        this.fetchForecastData();

        return;
      }
      if (this.typeLocation == "countie") {
        this.fetchForecastData();
        this.fetchDataTableCountie();

        return;
      }
    },

    toggleItemDaily(item) {
      if (this.selectedDaily.some((el) => el.id === item.id)) {
        if (this.selectedDaily.length > 1) {
          this.removeDaily(item);
        }
      } else {
        this.selectedDaily.push(item);
      }

      //   this.changeForecast();
      if (this.typeLocation == "regional") {
        this.fetchForecastData();
        this.fetchDataTableRegionals();
        this.fetchDataTableRegional();

        return;
      }
      if (this.typeLocation == "agency") {
        this.fetchDataTableAgency();
        this.fetchForecastData();

        return;
      }
      if (this.typeLocation == "countie") {
        this.fetchForecastData();
        this.fetchDataTableCountie();

        return;
      }
    },

    removeDaily(item) {
      if (this.selectedDaily.some((el) => el.id == item.id)) {
        let index = this.selectedDaily.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.selectedDaily.splice(index, 1);
        }
      }
    },

    isSelectedHour(item) {
      return this.selectedHour.some((el) => el.id === item.id);
    },

    removeHour(item) {
      if (this.selectedHour.some((el) => el.id == item.id)) {
        let index = this.selectedHour.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.selectedHour.splice(index, 1);
        }
      }
    },

    async fetchDataTableRegionals() {
      // this.createHeadersTable();
      this.loading = true;
      this.predictedDataItemsRegional = [];
      const filter = { ...this.filterSelected };
      const predictedData = [];
      const arrAuxPeriods = [];
      filter.runtimes = [];
      filter.typeSelected = "table";
      if (filter.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          await this.$store.dispatch(
            "fetchDailyHistoricalRegionalData",
            filter
          );
          predictedData.push(this.historicalRegionalData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedDaily.forEach((el) => {
              const runtime = moment(pe.runtime).utc().format("YYYY-MM-DD");
              const date = moment(el.date).utc().format("YYYY-MM-DD");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      if (filter.periodId == 2) {
        for (let datetime of this.hourlyDataFilter) {
          filter.date = datetime;
          await this.$store.dispatch(
            "fetchHourlyHistoricalRegionalData",
            filter
          );
          predictedData.push(this.historicalRegionalData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedHour.forEach((el) => {
              const runtime = moment(pe.runtime)
                .utc()
                .format("YYYY-MM-DD HH:mm");
              const date = moment(el.date).utc().format("YYYY-MM-DD HH:mm");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      this.predictedData = arrAuxPeriods;
      const groupedAgency = arrAuxPeriods.reduce((r, a) => {
        r[a.agencyIds[0]] = r[a.agencyIds[0]] || [];
        r[a.agencyIds[0]].push(a);
        return r;
      }, Object.create(null));

      const values = Object.values(groupedAgency);
      const arrAuxGroupedAgency = values;
      const arrPeriods = [];
      for (let e of arrAuxGroupedAgency) {
        const groupedPeriod = e.reduce((r, a) => {
          r[a.runtime] = r[a.runtime] || [];
          r[a.runtime].push(a);
          return r;
        }, Object.create(null));

        const values = Object.values(groupedPeriod);
        arrPeriods.push(values);
      }

      for (let data of arrPeriods) {
        for (let d of data) {
          for (let i in d) {
            if (filter.periodId == 1) {
              this.headers.forEach((el) => {
                if (d[i].date === el.date) {
                  d[i].column = el.value;
                }
              });
            } else {
              this.headers.forEach((el) => {
                if (moment(d[i].datetime).isSame(el.date)) {
                  d[i].column = el.value;
                }
              });
            }
          }
          const object = Object.assign(
            {},
            ...d.map((item) => ({
              [item.column]: item.sumCistart,
              ["agency"]: item.agencyIds[0],
              ...item,
            }))
          );

          this.predictedDataItemsRegional.push(object);
        }
      }

      this.predictedDataItemsRegional.sort((a, b) =>
        a.runtime < b.runtime ? -1 : a.runtime > b.runtime ? 1 : 0
      );

      this.predictedDataItemsRegionalCopy = [
        ...this.predictedDataItemsRegional,
      ];
      this.loading = false;
    },

    async fetchDataTableRegional() {
      this.forecastDataItemsRegional = [];

      this.loadingRegional = true;
      const predictedData = [];
      const filter = { ...this.filterSelected };
      const arrAuxPeriods = [];
      filter.runtimes = [];
      filter.typeSelected = "table";

      if (filter.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          await this.$store.dispatch(
            "fetchDailyHistoricalFullRegionalData",
            filter
          );

          predictedData.push(this.historicalFullRegional);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedDaily.forEach((el) => {
              const runtime = moment(pe.runtime).utc().format("YYYY-MM-DD");
              const date = moment(el.date).utc().format("YYYY-MM-DD");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      if (filter.periodId == 2) {
        filter.typeSelected = "table";
        for (let datetime of this.hourlyDataFilter) {
          filter.date = datetime;
          await this.$store.dispatch(
            "fetchHourlyHistoricalFullRegionalData",
            filter
          );
          predictedData.push(this.historicalFullRegional);
        }


        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedHour.forEach((el) => {
              const runtime = moment(pe.runtime)
                .utc()
                .format("YYYY-MM-DD HH:mm");
              const date = moment(el.date).utc().format("YYYY-MM-DD HH:mm");

              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      this.dataRegional = arrAuxPeriods;

      const groupedPeriod = arrAuxPeriods.reduce((r, a) => {
        r[a.runtime] = r[a.runtime] || [];
        r[a.runtime].push(a);
        return r;
      }, Object.create(null));

      const arrPeriods = Object.values(groupedPeriod);

      for (let data of arrPeriods) {
        for (let i in data) {
          if (filter.periodId == 1) {
            this.headers.forEach((el) => {
              if (data[i].date === el.date) {
                data[i].column = el.value;
              }
            });
          } else {
            this.headers.forEach((el) => {
              if (moment(data[i].datetime).isSame(el.date)) {
                data[i].column = el.value;
              }
            });
          }
        }
        const object = Object.assign(
          {},
          ...data.map((item) => ({
            [item.column]: item.sumCistart,
            ...item,
          }))
        );

        this.forecastDataItemsRegional.push(object);
      }

      this.loadingRegional = false;
    },

    async fetchDataTableAgency() {
      this.predictedDataItemsAgency = [];
      this.loading = true;
      const predictedData = [];
      const filter = { ...this.filterSelected };
      const arrAuxPeriods = [];
      filter.runtimes = [];

      filter.typeSelected = "table";

      if (filter.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          await this.$store.dispatch("fetchDailyHistoricalAgencyData", filter);
          predictedData.push(this.historicalAgencyData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedDaily.forEach((el) => {
              const runtime = moment(pe.runtime).utc().format("YYYY-MM-DD");
              const date = moment(el.date).utc().format("YYYY-MM-DD");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      if (filter.periodId == 2) {
        for (let datetime of this.hourlyDataFilter) {
          filter.date = datetime;

          await this.$store.dispatch("fetchHourlyHistoricalAgencyData", filter);
          predictedData.push(this.historicalAgencyData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedHour.forEach((el) => {
              const runtime = moment(pe.runtime)
                .utc()
                .format("YYYY-MM-DD HH:mm");
              const date = moment(el.date).utc().format("YYYY-MM-DD HH:mm");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      this.predictedData = arrAuxPeriods;
      const groupedCouties = arrAuxPeriods.reduce((r, a) => {
        r[a.locationId] = r[a.locationId] || [];
        r[a.locationId].push(a);
        return r;
      }, Object.create(null));

      const values = Object.values(groupedCouties);
      const arrAuxGroupedCouties = values;

      const arrPeriods = [];
      for (let e of arrAuxGroupedCouties) {
        const groupedPeriod = e.reduce((r, a) => {
          r[a.runtime] = r[a.runtime] || [];
          r[a.runtime].push(a);
          return r;
        }, Object.create(null));

        const values = Object.values(groupedPeriod);

        arrPeriods.push(values);
      }

      for (let data of arrPeriods) {
        for (let d of data) {
          for (let i in d) {
            if (filter.periodId == 1) {
              this.headers.forEach((el) => {
                if (d[i].date === el.date) {
                  d[i].column = el.value;
                }
              });
            } else {
              this.headers.forEach((el) => {
                if (moment(d[i].datetime).isSame(el.date)) {
                  d[i].column = el.value;
                }
              });
            }
          }
          const object = Object.assign(
            {},
            ...d.map((item) => ({
              [item.column]: item.cistart,
              ...item,
            }))
          );

          this.predictedDataItemsAgency.push(object);
        }
      }
      this.loading = false;
    },

    async fetchDataTableCountie() {
      this.predictedDataItemsCountie = [];
      this.loading = true;
      const predictedData = [];
      const filter = { ...this.filterSelected };
      const arrAuxPeriods = [];
      filter.runtimes = [];
      filter.typeSelected = "table";

      if (filter.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          await this.$store.dispatch("fetchDailyHistoricalCountieData", filter);

          predictedData.push(this.historicalCountieData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedDaily.forEach((el) => {
              const runtime = moment(pe.runtime).utc().format("YYYY-MM-DD");
              const date = moment(el.date).utc().format("YYYY-MM-DD");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }

      if (filter.periodId == 2) {
        filter.typeSelected = "table";
        for (let datetime of this.hourlyDataFilter) {
          filter.date = datetime;
          await this.$store.dispatch(
            "fetchHourlyHistoricalCountieData",
            filter
          );
          predictedData.push(this.historicalCountieData);
        }

        for (let periods of predictedData) {
          for (let pe of periods) {
            this.selectedHour.forEach((el) => {
              const runtime = moment(pe.runtime)
                .utc()
                .format("YYYY-MM-DD HH:mm");
              const date = moment(el.date).utc().format("YYYY-MM-DD HH:mm");
              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(pe);
              }
            });
          }
        }
      }
      this.predictedData = arrAuxPeriods;

      const groupedPeriod = arrAuxPeriods.reduce((r, a) => {
        r[a.runtime] = r[a.runtime] || [];
        r[a.runtime].push(a);
        return r;
      }, Object.create(null));

      const arrPeriods = Object.values(groupedPeriod);

      for (let data of arrPeriods) {
        for (let i in data) {
          if (filter.periodId == 1) {
            this.headers.forEach((el) => {
              if (data[i].date === el.date) {
                data[i].column = el.value;
              }
            });
          } else {
            this.headers.forEach((el) => {
              if (moment(data[i].datetime).isSame(el.date)) {
                data[i].column = el.value;
              }
            });
          }
        }
        const object = Object.assign(
          {},
          ...data.map((item) => ({
            [item.column]: item.cistart,
            ...item,
          }))
        );
        this.predictedDataItemsCountie.push(object);
      }

      this.loading = false;
    },

    async fetchDataTableleLightning() {
      this.predictedDataItemsLightning = [];
      this.loadingLightning = true;
      const registeredData = [];
      const filter = { ...this.filterSelected };

      if (filter.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");

          if (filter.type == "agency") {
            await this.$store.dispatch("fetchDailyLightningCountAgency", {
              date: filter.date,
              agencyIds: filter.location.id,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }
          if (filter.type == "regional") {
            await this.$store.dispatch("fetchDailyLightningCountRegional", {
              date: filter.date,
              regionalIds: filter.location.id,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }

          if (filter.type == "countie") {
            await this.$store.dispatch("fetchDailyLightningCountCity", {
              date: filter.date,
              locationIds: filter.location.cityId,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }
        }
      }

      if (filter.periodId == 2) {
        for (let date of this.hourlyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          const hour = moment(date).format("HH:mm");
          if (filter.type == "agency") {
            await this.$store.dispatch("fetchHourlyLightningCountAgency", {
              date: filter.date,
              hour: hour,
              agencyIds: filter.location.id,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }
          if (filter.type == "regional") {
            await this.$store.dispatch("fetchHourlyLightningCountRegional", {
              date: filter.date,
              hour: hour,
              regionalIds: filter.location.id,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }

          if (filter.type == "countie") {
            await this.$store.dispatch("fetchHourlyLightningCountCity", {
              date: filter.date,
              hour: hour,
              locationIds: filter.location.cityId,
            });

            const lightningData =
              this.lightningCountData.length != 0
                ? this.lightningCountData
                : [
                    {
                      sumData: "-",
                    },
                  ];
            registeredData.push(lightningData);
          }
        }
      }
      const arrAux = [];
      for (let data of registeredData) {
        for (let d of data) {
          arrAux.push(d);
        }
      }

      this.dataLightning = arrAux;

      const object = Object.assign(
        {},
        ...arrAux.map((item, index) => ({
          [`value${index}`]: item.sumData,
          ["registeredData"]: "Nuvem solo",
          ...item,
        }))
      );
      this.predictedDataItemsLightning.push(object);

      this.loadingLightning = false;
    },

    async fetchWeatherAlertTable() {
      this.loadingAlert = true;
      this.weatherAlertsItems = [];
      const filter = { ...this.filterSelected };
      await this.$store.dispatch(
        "fetchWeatherAgenciesOnAlertsTableData",
        filter
      );

      const weatherAlerts = [];
      this.weatherTableData.forEach((item) => {
        this.weatherAgenciesOnAlertsData.forEach((el) => {
          if (item.eventId == el.eventId && item.alertStart == el.alertStart) {
            item.agencies = el.agencies;
            weatherAlerts.push(item);
          }
        });
      });

      weatherAlerts.sort((a, b) =>
        a.alertStart < b.alertStart ? -1 : a.alertStart > b.alertStart ? 1 : 0
      );

      this.dataweatherAlerts = weatherAlerts;
      this.createHeadersAlert(weatherAlerts);
      const groupedAlertStart = weatherAlerts.reduce((r, a) => {
        r[a.alertStart] = r[a.alertStart] || [];
        r[a.alertStart].push(a);
        return r;
      }, Object.create(null));

      const valuesAlertStart = Object.values(groupedAlertStart);
      let arrEventName = [];
      let arrAlertArea = [];
      let arrAgency = [];
      valuesAlertStart.forEach((el) => {
        const objectEventName = Object.assign(
          {},
          ...el.map((item) => ({
            [`eventName`]: item.eventName,
          }))
        );
        arrEventName.push(objectEventName);
        const objectAlertArea = Object.assign(
          {},
          ...el.map((item) => ({
            [`alertArea`]: item.alertArea,
          }))
        );
        arrAlertArea.push(objectAlertArea);

        const objectAgency = Object.assign(
          {},
          ...el.map((item) => ({
            [`agencies`]: item.agencies,
          }))
        );

        arrAgency.push(objectAgency);
      });
      this.weatherAlertsItems = [
        Object.assign(
          {},
          ...arrEventName.map((item, index) => ({
            [`column${index}`]: item.eventName,
            ["typeData"]: "Intensidade",
          }))
        ),
      ];

      this.weatherAlertsItems.push(
        Object.assign(
          {},
          ...arrAlertArea.map((item, index) => ({
            [`column${index}`]: item.alertArea,
            ["typeData"]: "Área em alerta (%)",
          }))
        )
      );

      this.weatherAlertsItems.push(
        Object.assign(
          {},
          ...arrAgency.map((item, index) => ({
            [`column${index}`]: item.agencies,
            ["typeData"]: "Agências em alerta",
          }))
        )
      );

      this.loadingAlert = false;
    },

    createHeadersAlert(weatherAlerts) {
      const headersAll = [];
      this.headersAlert = [];
      weatherAlerts.forEach((el) => {
        headersAll.push(el.alertStart);
      });

      let headers = headersAll.filter(
        (este, i) => headersAll.indexOf(este) === i
      );

      this.headersAlert.push({
        text: "Dados do alerta",
        align: "start",
        sortable: false,
        value: "typeData",
        class: "header-previst header-text",
        width: "180px",
      });
      headers.forEach((el, index) => {
        this.headersAlert.push({
          text: moment(el).format("ddd. DD/MM/YYYY HH:mm"),
          value: `column${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
          width: "192.2px",
        });
      });
    },

    createWindTable(forecasts) {
      this.forecastsDataItemsWind = [];
      if (this.filterSelected.type != "countie") {
        this.forecastsDataItemsWind = this.dataRecordedStations.map(
          (item) => item
        );
      }

      const groupedForecasts = [...forecasts];

      if (this.filterSelected.periodId == 1) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersWindGust.forEach((el) => {
              if (item.date === el.date) {
                item.column = el.value;
              }
            });
          });
        }
      }

      if (this.filterSelected.periodId == 2) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersWindGust.forEach((el) => {
              const datetime = moment(item.datetime).format(
                "YYYY-MM-DD[T]HH:mm:ss"
              );

              if (datetime === el.date) {
                item.column = el.value;
              }
            });
          });
        }
      }

      for (let i in groupedForecasts) {
        const object = Object.assign(
          {},
          ...groupedForecasts[i].map((item) => ({
            [item.column]: item.windGust,
            color: "#b4dbff",
            background: "rgba(75, 166, 251, 0.1)",
            height: "78px",
            ...item,
          }))
        );

        this.forecastsDataItemsWind.push(object);
      }

      this.forecastsDataItemsWind.sort((a, b) =>
        a.runtime < b.runtime ? -1 : a.runtime > b.runtime ? 1 : 0
      );

      this.forecastsDataItemsWindCopy = [...this.forecastsDataItemsWind];
    },

    createPrecipTable(forecasts) {
      this.forecastsDataItemsPrecip = [];
      this.forecastsDataItemsPrecipCopy = [];
      if (this.filterSelected.type != "countie") {
        this.forecastsDataItemsPrecip = this.dataRecordedStations.map(
          (item) => item
        );

        this.forecastsDataItemsPrecipCopy = this.dataRecordedStations.map(
          (item) => item
        );
      }

      const groupedForecasts = [...forecasts];
      if (this.filterSelected.periodId == 1) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersPreci.forEach((el) => {
              if (item.date === el.date) {
                item.column = el.value;
              }
            });
          });
        }
      }

      if (this.filterSelected.periodId == 2) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersPreci.forEach((el) => {
              const datetime = moment(item.datetime).format(
                "YYYY-MM-DD[T]HH:mm:ss"
              );

              if (datetime === el.date) {
                item.column = el.value;
              }
            });
          });
        }
      }

      for (let data of groupedForecasts) {
        const object = Object.assign(
          {},
          ...data.map((item, index) => ({
            [`value${index}`]: item.date,
            [item.column]: item.precIntensity,
            color: "#b4dbff",
            background: "rgba(75, 166, 251, 0.1)",
            height: "78px",
            ...item,
          }))
        );
        this.forecastsDataItemsPrecip.sort((a, b) =>
          a.runtime < b.runtime ? -1 : a.runtime > b.runtime ? 1 : 0
        );

        this.forecastsDataItemsPrecip.push(object);
        this.forecastsDataItemsPrecipCopy.push(object);
      }
    },

    createTempTable(groupedForecasts) {
      this.forecastsDataItemsTemp = [];

      if (this.filterSelected.type != "countie") {
        this.forecastsDataItemsTemp = this.dataRecordedStations.map(
          (item) => item
        );
      }

      if (this.filterSelected.periodId == 1) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersTemp.forEach((el) => {
              if (item.date === el.date) {
                item.column = el.value;
                item.columnTemMax = el.columnTemMax;
              }
            });
          });
        }
      }

      if (this.filterSelected.periodId == 2) {
        for (let index in groupedForecasts) {
          groupedForecasts[index].forEach((item) => {
            this.headersTemp.forEach((el) => {
              const datetime = moment(item.datetime).format(
                "YYYY-MM-DD[T]HH:mm:ss"
              );
              if (datetime === el.date) {
                item.column = el.value;
              }
            });
          });
        }
      }
      for (let data of groupedForecasts) {
        const object = Object.assign(
          {},
          ...data.map((item) => ({
            [item.date]: item.date,
            [item.column]: this.daily ? item.tempMin : item.temp,
            [item.columnTemMax]: item.tempMax,
            color: "#b4dbff",
            background: "rgba(75, 166, 251, 0.1)",
            height: "78px",
            ...item,
          }))
        );
        this.forecastsDataItemsTemp.sort((a, b) =>
          a.runtime < b.runtime ? -1 : a.runtime > b.runtime ? 1 : 0
        );

        this.forecastsDataItemsTemp.push(object);
      }
    },
    async fetchForecastData() {
      this.loadingForecast = true;
      const predictedData = [];
      const recordedData = [];
      const arrAuxPeriods = [];
      this.forecastsDataItemsWind = [];
      this.forecastsDataItemsPrecip = [];
      this.forecastsDataItemsTemp = [];
      this.registeredDataItems = [];
      const filter = { ...this.filterSelected };

      if (this.filterSelected.periodId == 1) {
        for (let date of this.dailyDataFilter) {
          filter.date = moment(date).format("YYYY-MM-DD");
          filter.runtimeHourMinute = "00:00";
          filter.runtimes = [];
          if (filter.type == "regional") {
            await this.$store.dispatch(
              "fetchDailyHistoricalForecastsRegionals",
              filter
            );

            predictedData.push(this.historicalForecastsData);
          }

          if (filter.type == "agency") {
            await this.$store.dispatch(
              "fetchDailyHistoricalForecastsAgencies",
              filter
            );
            predictedData.push(this.historicalForecastsData);
          }

          if (filter.type == "countie") {
            await this.$store.dispatch(
              "fetchDailyHistoricalForecastsCouties",
              filter
            );

            await this.$store.dispatch(
              "fetchRecordedDataFromTelmetryStationsDailyCity",
              {
                cityId: filter.location.cityId,
                date: filter.date,
              }
            );

            const registeredData =
              this.recordedDataFromTelmetryStations.length != 0
                ? this.recordedDataFromTelmetryStations
                : [
                    {
                      windGust: "-",
                      accumPrec: "-",
                      maxPrec: "-",
                      minTemp: "-",
                      maxTemp: "-",
                      meanTemp: "-",
                    },
                  ];
            predictedData.push(this.historicalForecastsData);
            recordedData.push(registeredData);
          }
        }
        await this.getDataRecordedStationCounty(filter);
        await this.searchBiggerStationData();

        for (let periods of predictedData) {
          for (let i = periods.length; i > 10; i--) {
            this.selectedDaily.forEach((el) => {
              const runtime = moment(periods[i - 1].runtime)
                .utc()
                .format("YYYY-MM-DD");
              const date = moment(el.date).utc().format("YYYY-MM-DD");

              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(periods[i - 1]);
              }
            });
          }
        }

        this.forecastsDataItems = arrAuxPeriods.map((item) => item);
        this.forecastsDataItemsCopy = arrAuxPeriods.map((item) => item);
      }

      if (this.filterSelected.periodId == 2) {
        await this.getDataRecordedStationCounty(filter);
        await this.searchBiggerStationData();

        filter.typeSelected = "table";

        for (let datetime of this.hourlyDataFilter) {
          filter.date = datetime;

          if (filter.type == "regional") {
            await this.$store.dispatch(
              "fetchHourlyHistoricalForecastsRegionals",
              filter
            );

            predictedData.push(this.historicalForecastsData);
          }

          if (filter.type == "agency") {
            await this.$store.dispatch(
              "fetchHourlyHistoricalForecastsAgencies",
              filter
            );

            predictedData.push(this.historicalForecastsData);
          }

          if (filter.type == "countie") {
            await this.$store.dispatch(
              "fetchHourlyHistoricalForecastsCouties",
              filter
            );

            await this.$store.dispatch(
              "fetchRecordedDataFromTelmetryStationsHourlyCity",

              filter
            );

            const registeredData =
              this.recordedDataFromTelmetryStations.length != 0
                ? this.recordedDataFromTelmetryStations
                : [
                    {
                      windGust: "-",
                      accumPrec: "-",
                      maxPrec: "-",
                      minTemp: "-",
                      maxTemp: "-",
                      meanTemp: "-",
                    },
                  ];

            predictedData.push(this.historicalForecastsData);
            recordedData.push(registeredData);
          }
        }

        for (let periods of predictedData) {
          for (let period of periods) {
            /*             this.selectedHour.forEach((el) => {
              const runtime = moment(period.runtime).format("YYYY-MM-DD HH:mm");
              const date = moment(el.date).format("YYYY-MM-DD HH:mm");

              if (moment(runtime).isSame(date)) {
                arrAuxPeriods.push(period);
              }
            }); */

            arrAuxPeriods.push(period);
          }
        }
        this.forecastsDataItems = arrAuxPeriods.map((item) => item);
      }

      const groupedForecasts = arrAuxPeriods.reduce((r, a) => {
        r[a.runtime] = r[a.runtime] || [];
        r[a.runtime].push(a);
        return r;
      }, Object.create(null));

      const forecasts = Object.values(groupedForecasts);

      this.createWindTable(forecasts);
      this.createPrecipTable(forecasts);
      this.createTempTable(forecasts);

      for (let data of recordedData) {
        for (let d of data) {
          this.registeredDataItems.push(d);
        }
      }
      this.loadingForecast = false;
    },

    createHeadersTable() {
      this.headers = [];
      this.headersLightning = [];
      this.headersWindGust = [];
      this.headersPreci = [];
      this.headersTemp = [];
      this.headers.push({
        text: "Previsto em",
        align: "start",
        sortable: false,
        value: "runtime",
        class: "header-previst header-text",
      });

      this.headersWindGust.push({
        text: "Previsto em",
        align: "start",
        sortable: false,
        value: "runtime",
        class: "header-previst header-text",
      });

      this.headersLightning.push({
        text: "Dados de Raios",
        align: "start",
        sortable: false,
        value: "registeredData",
        class: "header-lightning  header-lightning-text",
      });

      this.headersPreci.push({
        text: "Previsto em",
        align: "start",
        sortable: false,
        value: "runtime",
        class: "header-previst header-text",
      });

      this.headersTemp.push({
        text: "Previsto em",
        align: "start",
        sortable: false,
        value: "runtime",
        class: "header-previst header-text",
      });

      const dataFilter =
        this.daily == true ? this.dailyDataFilter : this.hourlyDataFilter;

      for (let index in dataFilter) {
        this.headers.push({
          text:
            this.daily == true
              ? moment(dataFilter[index]).format("ddd. DD/MM/YYYY")
              : moment(dataFilter[index]).utc().format("ddd. DD/MM/YYYY HH:mm"),
          value: `column${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
          date:
            this.daily == true
              ? `${moment(dataFilter[index]).format("YYYY-MM-DD")}`
              : `${moment(dataFilter[index]).format("YYYY-MM-DD[T]HH:mm:ss")}`,
          index: index,
        });

        this.headersWindGust.push({
          text:
            this.daily == true
              ? moment(dataFilter[index]).format("ddd. DD/MM/YYYY")
              : moment(dataFilter[index]).utc().format("ddd. DD/MM/YYYY HH:mm"),
          value: `windGust${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
          date:
            this.daily == true
              ? `${moment(dataFilter[index]).format("YYYY-MM-DD")}`
              : moment(this.hourlyDataFilter[index]).format(
                  "YYYY-MM-DD[T]HH:mm:ss"
                ),
          index: index,
        });

        this.headersPreci.push({
          text:
            this.daily == true
              ? moment(dataFilter[index]).format("ddd. DD/MM/YYYY")
              : moment(dataFilter[index]).utc().format("ddd. DD/MM/YYYY HH:mm"),
          value: `accumPrec${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
          date:
            this.daily == true
              ? `${moment(dataFilter[index]).format("YYYY-MM-DD")}`
              : moment(this.hourlyDataFilter[index]).format(
                  "YYYY-MM-DD[T]HH:mm:ss"
                ),
          index: index,
        });

        this.headersTemp.push({
          text:
            this.daily == true
              ? moment(dataFilter[index]).format("ddd. DD/MM/YYYY")
              : moment(dataFilter[index]).utc().format("ddd. DD/MM/YYYY HH:mm"),
          value: this.daily ? `tempMin${index}` : `tempMed${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
          date:
            this.daily == true
              ? `${moment(dataFilter[index]).format("YYYY-MM-DD")}`
              : moment(this.hourlyDataFilter[index]).format(
                  "YYYY-MM-DD[T]HH:mm:ss"
                ),
          index: index,
          columnTemMax: `tempMax${index}`,
          width: "292.4px",
        });

        this.headersLightning.push({
          text:
            this.daily == true
              ? moment(dataFilter[index]).format("ddd. DD/MM/YYYY")
              : moment(dataFilter[index]).utc().format("ddd. DD/MM/YYYY HH:mm"),
          value: `value${index}`,
          class: "headers-style headers-text",
          divider: true,
          align: "end",
        });
      }
    },

    changeFilter() {
      if (this.typeLocation == "regional") {
        this.fetchForecastData();
        this.fetchDataTableRegionals();
        this.fetchDataTableleLightning();
        this.fetchWeatherAlertTable();
        this.fetchDataTableRegional();

        return;
      }
      if (this.typeLocation == "agency") {
        this.fetchDataTableleLightning();
        this.fetchDataTableAgency();
        this.fetchForecastData();

        return;
      }
      if (this.typeLocation == "countie") {
        this.fetchForecastData();
        this.fetchDataTableleLightning();
        this.fetchDataTableCountie();

        return;
      }
    },

    createStyleHeader(index) {
      if (index != 0) {
        return "text-end v-data-table__divider headers-style headers-text v-data-table--fixed-header";
      }
      return "header-previst ";
    },
    createStyleItem(index) {
      if (index != 0) {
        return "text-end v-data-table__divider";
      }
      return "header-previst ";
    },

    getWindGustTypeColor(valor) {
      if (valor < 40) {
        return "#828D9E";
      }

      if (valor >= 40 && valor < 55) {
        return "#E6C000";
      }
      if (valor >= 55 && valor < 70) {
        return "#DF9F3E";
      }

      if (valor >= 70 && valor < 90) {
        return "#B4374B";
      }

      if (valor >= 90) {
        return "#873764";
      }

      return "#F2F2F2";
    },

    getPreciTypeColor(valor) {
      if (valor < 15) {
        return "#9E9E9E";
      }

      if (valor >= 15 && valor < 40) {
        return "#BED7DC";
      }
      if (valor >= 40 && valor < 55) {
        return "#9BC3CD";
      }

      if (valor >= 55 && valor < 105) {
        return "#73A5B4";
      }

      if (valor >= 105 && valor < 155) {
        return "#4b879b";
      }

      if (valor >= 155) {
        return "#286E82";
      }

      return "#F2F2F2";
    },

    getTempTypeColor(valor) {
      if (valor < 6) {
        return "#002D55";
      }

      if (valor >= 6 && valor < 35) {
        return "#A5CD78";
      }
      if (valor >= 35) {
        return "#9B1400";
      }

      return "#F2F2F2";
    },

    getNameCounty(locationId) {
      for (let county of this.listCities) {
        if (county.locationId == locationId) {
          return county.locationName;
        }
      }
    },

    async getDataRecordedStationCounty(filter) {
      this.dataRecordedStations = [];
      if (filter.periodId == 1) {
        let startDate = filter.startDate;
        let endDate = filter.endDate;

        startDate = moment(startDate).format("YYYY-MM-DD");
        endDate = moment(endDate).format("YYYY-MM-DD");
        if (filter.type == "regional") {
          await this.$store.dispatch("fetchRegionalCitiesDailySummary", {
            startDate: startDate,
            endDate: endDate,
            id: filter.location.id,
          });
        }

        if (filter.type == "agency") {
          await this.$store.dispatch("fetchAgencylCitiesDailySummary", {
            startDate: startDate,
            endDate: endDate,
            id: filter.location.id,
          });
        }
      }

      if (filter.periodId == 2) {
        const startDatetime = moment(filter.date)
          .hour(filter.hourStart)
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        const endDatetime = moment(filter.date)
          .hour(filter.hourEnd)
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        if (filter.type == "regional") {
          await this.$store.dispatch("fetchRegionalCitiesHourlySummary", {
            startDatetime: startDatetime,
            endDatetime: endDatetime,
            id: filter.location.id,
          });
        }

        if (filter.type == "agency") {
          await this.$store.dispatch("fetchAgencylCitiesHourlySummary", {
            startDatetime: startDatetime,
            endDatetime: endDatetime,
            id: filter.location.id,
          });
        }
      }

      for (let couties of this.hsitoricalRegionalCitiesSummary) {
        const object = Object.assign(
          {},
          ...couties.values.map((item, index) => ({
            [`tempMax${index}`]: item.maxTemp,
            [`tempMin${index}`]: item.minTemp,
            [`tempMed${index}`]: item.meanTemp,
            [`windGust${index}`]: item.wintGust,
            [`accumPrec${index}`]: item.accumPrec,
            [`cityName`]: this.getNameCounty(couties.cityId),
            [`runtime`]: this.getNameCounty(couties.cityId),
            agroup: "agroup",
            [`color`]: "#558a80",
            [`background`]: "#e7fdf5",
            height: "78px",
          }))
        );

        this.dataRecordedStations.push(object);
      }
    },

    async searchBiggerStationData() {
      const arrAuxCouties = [];
      this.higherStationData = [];
      for (let couties of this.hsitoricalRegionalCitiesSummary) {
        for (let county of couties.values) {
          arrAuxCouties.push(county);
        }
      }

      let groupCoutiesByDate = null;

      if (this.filterSelected.periodId == 1) {
        groupCoutiesByDate = arrAuxCouties.reduce((r, a) => {
          r[a.date] = r[a.date] || [];
          r[a.date].push(a);
          return r;
        }, Object.create(null));
      }

      if (this.filterSelected.periodId == 2) {
        groupCoutiesByDate = arrAuxCouties.reduce((r, a) => {
          r[a.datetime] = r[a.datetime] || [];
          r[a.datetime].push(a);
          return r;
        }, Object.create(null));
      }
      groupCoutiesByDate = Object.values(groupCoutiesByDate);

      for (let couties of groupCoutiesByDate) {
        let bigger = {
          greaterAccumPrec: 0,
          windGust: 0,
          date: null,
          minTemp: 0,
          maxTemp: 0,
          medTemp: 0,
        };
        for (let county of couties) {
          bigger.date = county.date;
          if (county.accumPrec > bigger.greaterAccumPrec) {
            bigger.greaterAccumPrec = county.accumPrec;
          }

          if (county.wintGust > bigger.windGust) {
            bigger.windGust = county.wintGust;
          }

          if (county.maxTemp > bigger.maxTemp) {
            bigger.maxTemp = county.maxTemp;
          }

          if (county.minTemp > bigger.minTemp) {
            bigger.minTemp = county.minTemp;
          }

          if (county.meanTemp > bigger.medTemp) {
            bigger.medTemp = county.meanTemp;
          }
        }
        this.higherStationData.push(bigger);
      }
      if (this.filterSelected.periodId == 1) {
        this.higherStationData.pop();
      }
    },

    getBiggestStation(value, index, station) {
      if (!this.higherStationData[index]) {
        return false;
      }

      if (station == "precipitation") {
        if (this.higherStationData[index].greaterAccumPrec == value) {
          return true;
        }
      }

      if (station == "windGust") {
        if (this.higherStationData[index].windGust == value) {
          return true;
        }
      }

      if (station == "temp") {
        if (this.higherStationData[index].maxTemp == value) {
          return true;
        }
      }

      if (station == "tempMed") {
        if (this.higherStationData[index].medTemp == value) {
          return true;
        }
      }

      return false;
    },

    backToPreviousScreen() {
      this.$router.go(-1);
    },

    toggleNavigation() {
      this.$emit("toggleNavigation");
    },

    changeToFullSreen(tableId) {
      let elem = document.getElementById(tableId);
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },

    intensityColor(intensity) {
      if (intensity == "T0") {
        return "#DCE775";
      }
      if (intensity == "T1" || intensity == "T2") {
        return "#CDDC39";
      }
      if (intensity == "T3" || intensity == "T4") {
        return "#FDE047";
      }
      if (intensity == "T5" || intensity == "T6") {
        return "#FF9F00";
      }
      if (intensity == "T7" || intensity == "T8") {
        return "#FB2E33";
      }
      if (intensity == "T9" || intensity == "T10") {
        return "#D40D12";
      }

      return "#F2F2F2";
    },

    exportXLS(type) {
      const regionalLabel = (regional) => {
        if (regional == 88) {
          return 'DOCCMN';
        }
        if (regional == 89) {
          return 'DOCCSL';
        }
        if (regional == 90) {
          return 'DOCMSL';
        }
        if (regional == 91) {
          return 'DOCNRO';
        }
        if (regional == 92) {
          return 'DOCNRT';
        }
        if (regional == 93) {
          return 'DOCOST';
        }
        if (regional == 94) {
          return 'DOCSUD';
        }
      };

      const resultsLabel = (result) => {
        if (result == "zero") {
          return "zero";
        }

        if (result == "low") {
          return "baixo";
        }

        if (result == "medium") {
          return "médio";
        }

        if (result == "high") {
          return "alto";
        }
      };
      if (type == "regional") {
        const rows = [];

        this.predictedData.forEach((item) => {
          rows.push({
            agência: item.agencyIds[0],
            regional: regionalLabel(item.regionalId),
            sumCistart: item.sumCistart,
            data: item.date,
            runtime: item.runtime,
          });
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "previsão-de-consumidor-interompido-agencias.xlsx");
      }

      if (type == "oneRegional") {
        const rows = [];

        this.dataRegional.forEach((item) => {
          rows.push({
            regional: regionalLabel(item.regionalId),
            sumCistart: item.sumCistart,
            data: item.date,
            runtime: item.runtime,
          });
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "previsão-de-consumidor-interompido-regional.xlsx");
      }

      if (type == "agency") {
        const rows = [];

        this.predictedData.forEach((item) => {
          rows.push({
            locationName: item.locationName,
            agência: this.filterSelected.location.id,
            cistart: item.cistart,
            cistop: item.cistop,
            resultado: resultsLabel(item.result),
            data: item.date,
            previsto: item.runtime,
          });
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(
          wb,
          "previsão-de-consumidor-interompido-municipios.xlsx"
        );
      }

      if (type == "countie") {
        const rows = [];
        this.predictedData.forEach((item) => {
          rows.push({
            locationName: this.filterSelected.location.name,
            locationId: item.locationId,
            cistart: item.cistart,
            cistop: item.cistop,
            resultado: resultsLabel(item.result),
            data: item.date,
            previsto: item.runtime,
          });
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "previsão-de-consumidor-interompido-municipio.xlsx");
      }

      if (type == "wind") {
        const rows = [];
        this.forecastsDataItems.forEach((item) => {
          if (item.regionalId) {
            rows.push({
              rajadaMáxima: item.windGust,
              regional: regionalLabel(item.regionalId),
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }

          if (item.agencyIds) {
            rows.push({
              rajadaMáxima: item.windGust,
              agencyId: item.agencyIds[0],
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }

          if (item.locationId) {
            rows.push({
              rajadaMáxima: item.windGust,
              locationId: item.locationId,
              locationName: this.getNameCounty(item.locationId),
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "rajada-máxima-de-vento.xlsx");
      }

      if (type == "preci") {
        const rows = [];
        this.forecastsDataItems.forEach((item) => {
          if (item.regionalId) {
            rows.push({
              precipitacaoIntencidade: item.precIntensity,
              preciIntencidadeAcumulada: item.precIntensityAccum,
              regional: regionalLabel(item.regionalId),
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }

          if (item.agencyIds) {
            rows.push({
              precipitacaoIntencidade: item.precIntensity,
              preciIntencidadeAcumulada: item.precIntensityAccum,
              agencyId: item.agencyIds[0],
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }

          if (item.locationId) {
            rows.push({
              precipitacaoIntencidade: item.precIntensity,
              preciIntencidadeAcumulada: item.precIntensityAccum,
              locationId: item.locationId,
              locationName: this.getNameCounty(item.locationId),
              data: item.date ? item.date : item.datetime,
              previsto: item.runtime,
            });
          }
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "precipitacao.xlsx");
      }

      if (type == "temp") {
        const rows = [];
        this.forecastsDataItems.forEach((item) => {
          if (item.regionalId) {
            rows.push({
              tempMax: item.tempMax,
              tempMin: item.tempMin,
              tempMed: item.temp,
              regional: regionalLabel(item.regionalId),

              data: item.date,
              previsto: item.runtime,
            });
          }

          if (item.agencyIds) {
            rows.push({
              tempMax: item.tempMax,
              tempMin: item.tempMin,
              tempMed: item.temp,
              agencyId: item.agencyIds[0],
              data: item.date,
              previsto: item.runtime,
            });
          }

          if (item.locationId) {
            rows.push({
              tempMax: item.tempMax,
              tempMin: item.tempMin,
              tempMed: item.temp,
              locationId: item.locationId,
              locationName: this.getNameCounty(item.locationId),
              data: item.date,
              previsto: item.runtime,
            });
          }
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "temperatura.xlsx");
      }

      if (type == "lightning") {
        const rows = [];

        this.dataLightning.forEach((item) => {
          if (item.type == "regional") {
            rows.push({
              regional: item.name,
              data: item.date ? item.date : item.datetime,
              totalRegional: item.sumData,
            });
          }

          if (item.type == "agency") {
            rows.push({
              agencia: item.name,
              data: item.date ? item.date : item.datetime,
              totalAgencia: item.sumData,
            });
          }

          if (item.type == "city") {
            rows.push({
              locationName: item.name,
              data: item.date ? item.date : item.datetime,
              totalMuicipio: item.sumData,
            });
          }
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "raios.xlsx");
      }

      if (type == "weatherAlerts") {
        const rows = [];

        this.dataweatherAlerts.forEach((item) => {
          moment(item.alertStart).format("DD/MM/YYYY");
          rows.push({
            agencias: item.agencies,
            alertaArea: item.alertArea,
            intensidade: item.eventName,
            enviadoAlerta: moment(item.alertStart).format("DD/MM/YYYY"),
            finalAlerta: item.alertEnd,
            regional: item.alertEnd,
          });
        });

        const data = xlsx.utils.json_to_sheet(rows);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, data, "data");
        xlsx.writeFile(wb, "alertas.xlsx");
      }
    },
  },
};
</script>


<style lang="scss">
.ci-forecast-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  color: var(--v-primary-base);
}

.ci-forecast-sub-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.1px;
  color: var(--v-primary-base);
}

.forecast-time-text {
  text-align: end;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.graph-table-chip {
  border-radius: 8px;
  background-color: var(--v-secondary-base);
  padding: 6px;
}

.daily-btn {
  margin-right: 4px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-accent-base);
  border: 1px solid var(--v-accent-base);
  border-radius: 4px;
  background-color: var(--v-secondary-base) !important;
  text-transform: none;
  .daily-btn-icon {
    color: #bac2cf;
  }
}

.daily-btn-active {
  background-color: var(--v-accent-base) !important;
  border: 1px solid var(--v-accent-base);
  .daily-btn-text {
    color: var(--v-primary-base);
  }
}

.card-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
}

.card-subtitle {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #d9d9d9;
}

.card-style {
  width: 100%;
  margin-right: 12px;
  border-radius: 16px;
}

.header-previst {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  background: rgba(75, 166, 251, 0.1) !important;
  width: 180px;
  height: 36px;
}

.header-text {
  color: #b4dbff !important;
}

.headers-style {
  background-color: #1b1f2d;
  width: 190px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

.headers-text {
  color: #f2f2f2 !important;
}

.theme--dark.v-data-table {
  background-color: #151723;
  color: #ffffff;
  border-radius: 8px;
  border: 2px solid #191c29;
}

::v-deep .td-header-agency {
  background-color: rgba(255, 222, 192, 0.03) !important;
  height: 36px;
}

.group-agency {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 6px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  letter-spacing: 0.5px;

  /* Brand UI/Primária 100 */

  color: #f5821e;
}
.theme--dark.v-data-table .v-row-group__header,
.theme--dark.v-data-table .v-row-group__summary {
  background: rgba(255, 222, 192, 0.03);
  height: 36px;
}

.theme--dark.v-data-table.v-data-table--fixed-header thead th {
  background-color: #1b1f2d;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
}

#predictionDataTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  height: 6px;
  background-color: var(--v-secondary-base);
}

/* Handle */
#predictionDataTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: var(--v-accent-base);
  border-radius: 2px;
}

/* Handle on hover */

#predictionDataTable .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--v-accent-lighten1);
  width: 1px;
}

.header-sub-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}

.item-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.header-lightning {
  width: 180px;
  height: 36px;
  background: #e7fdf5 !important;
  border-radius: 8px 0px 0px 0px;
}

.header-lightning-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #558a80 !important;
}

.ellipse-legend {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transform: rotate(-10deg);
  border: 1px solid;
}

.legend-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.legend-style {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
}

.legend-chip {
  display: flex;
  flex-direction: row;
}

.historical-data-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.historical-data-sub-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: var(--v-primary-darken2);
}

.alert-weather {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
  width: 1526px;
  max-height: 60px;
  background: #ffefe1;
  border-radius: 8px;
}

.info-alert-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #e67e22;
}

.info-alert-subtitle {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #e67e22;
}
.header-width {
  width: 192.2px;
}

.btn-filter {
  text-transform: none;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}
</style>


